<template>
  <div
    data-elementor-type="wp-page"
    data-elementor-id="49887"
    class="elementor elementor-49887"
    data-elementor-post-type="page"
  >
    <img
      v-if="client.foto_cover"
      :src="getCoverImageUrl(client.foto_cover)"
      alt=""
      fetchpriority="high"
      loading="eager"
      decoding="async"
      style="position:absolute; width:1px; height:1px; opacity:0; pointer-events:none;"
    />
    <div
      class="elementor-element elementor-element-672ed1dc e-con-full notranslate e-flex e-con e-parent e-lazyloaded"
      data-id="672ed1dc"
      data-element_type="container"
      data-e-type="container"
    >
      <div
        class="elementor-element elementor-element-4f949def elementor-hidden-mobile e-con-full e-flex e-con e-child"
        data-id="4f949def"
        data-element_type="container"
        data-e-type="container"
        data-settings='{"background_background":"classic"}'
        :style="{ backgroundColor: '#1b1b1b', backgroundImage: (client.foto_cover && coverLoaded) ? `url('${getCoverImageUrl(client.foto_cover)}')` : 'none', backgroundPosition: 'center center', backgroundSize: 'cover' }"
      >
        <div
          class="elementor-element elementor-element-66fad91a animated-slow elementor-widget elementor-widget-heading animated fadeInUp"
          data-id="66fad91a"
          data-element_type="widget"
          data-e-type="widget"
          data-settings='{"_animation":"fadeInUp"}'
          data-widget_type="heading.default"
        >
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">{{pasangan}}</h2>
          </div>
        </div>
        <div
          class="elementor-element elementor-element-1c49b60e elementor-widget elementor-widget-heading"
          data-id="1c49b60e"
          data-element_type="widget"
          data-e-type="widget"
          data-widget_type="heading.default"
        >
          <div class="elementor-widget-container">
            <p class="elementor-heading-title elementor-size-default"> Find someone who knows that you are not perfect but treats you as if you are. </p>
          </div>
        </div>
      </div>
      <div
        class="elementor-element elementor-element-66d5bded e-con-full e-flex e-con e-child"
        data-id="66d5bded"
        data-element_type="container"
        data-e-type="container"
        data-settings='{"background_background":"classic"}'
      >
        <div
          class="elementor-element elementor-element-6e935c17 e-con-full e-flex e-con e-child"
          data-id="6e935c17"
          data-element_type="container"
          data-e-type="container"
          id="section-cover"
        >
          <div
            class="elementor-element elementor-element-12234eac e-con-full e-flex e-con e-child"
            data-id="12234eac"
            data-element_type="container"
            data-e-type="container"
            data-settings='{"background_background":"classic"}'
          >
            <div
              class="elementor-element elementor-element-3e857c4 e-con-full e-flex e-con e-child"
              data-id="3e857c4"
              data-element_type="container"
              data-e-type="container"
              data-settings='{"background_background":"classic"}'
            >
              <div
                class="elementor-element elementor-element-48226954 elementor-widget-divider--view-line_text elementor-widget-divider--element-align-right elementor-widget elementor-widget-divider animated fadeInLeft"
                data-id="48226954"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInLeft"}'
                data-widget_type="divider.default"
              >
                <div class="elementor-widget-container">
                  <div class="elementor-divider">
                    <span class="elementor-divider-separator">
                      <span class="elementor-divider__text elementor-divider__element"> We're getting married </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-2784d458 e-con-full e-flex e-con e-child"
              data-id="2784d458"
              data-element_type="container"
              data-e-type="container"
              data-settings='{"background_background":"classic"}'
            >
              <div
                class="elementor-element elementor-element-122832ce e-con-full e-flex e-con e-child"
                data-id="122832ce"
                data-element_type="container"
                data-e-type="container"
              >
                <div
                  class="elementor-element elementor-element-5788c62a e-con-full e-flex e-con e-child"
                  data-id="5788c62a"
                  data-element_type="container"
                  data-e-type="container"
                >
                  <div
                    class="elementor-element elementor-element-77882976 e-transform elementor-widget-divider--view-line elementor-widget elementor-widget-divider animated fadeInUp"
                    data-id="77882976"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_transform_rotateZ_effect":{"unit":"px","size":90,"sizes":[]},"_animation":"fadeInUp","_transform_rotateZ_effect_tablet":{"unit":"deg","size":"","sizes":[]},"_transform_rotateZ_effect_mobile":{"unit":"deg","size":"","sizes":[]}}'
                    data-widget_type="divider.default"
                  >
                    <div class="elementor-widget-container">
                      <div class="elementor-divider">
                        <span class="elementor-divider-separator"> </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-130a1884 e-con-full e-flex e-con e-child"
                  data-id="130a1884"
                  data-element_type="container"
                  data-e-type="container"
                >
                  <div
                    class="elementor-element elementor-element-d098985 elementor-widget-mobile__width-inherit animated-slow e-transform text-center elementor-widget elementor-widget-tp-advanced-typography animated fadeInUp"
                    data-id="d098985"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"fadeInUp","_transform_rotateZ_effect":{"unit":"px","size":270,"sizes":[]},"_transform_rotateZ_effect_mobile":{"unit":"deg","size":270,"sizes":[]},"_transform_rotateZ_effect_tablet":{"unit":"deg","size":"","sizes":[]}}'
                    data-widget_type="tp-advanced-typography.default"
                  >
                    <div class="elementor-widget-container">
                      <div id="atd098985" class="pt-plus-adv-typo-wrapper">
                        <div class="pt_plus_adv_typo_block none">
                          <span
                            id="advtypo6a12f5f198197"
                            class="text-content-block"
                            style="
                              max-block-size: max-content;
                              writing-mode: vertical-lr;
                              -webkit-writing-mode: vertical-lr;
                              -ms-writing-mode: vertical-lr;
                            "
                            >{{ moment (client.tgl_resepsi).locale(config.language === 1 ? 'en' : 'id').format('DD MMMM YYYY') }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-22101eae e-con-full e-flex e-con e-child"
                data-id="22101eae"
                data-element_type="container"
                data-e-type="container"
              >
                <div
                  class="elementor-element elementor-element-71ba690f e-con-full e-flex e-con e-child"
                  data-id="71ba690f"
                  data-element_type="container"
                  data-e-type="container"
                >
                  <div
                    class="elementor-element elementor-element-1ed4ae44 elementor-widget elementor-widget-image animated slideInUp"
                    data-id="1ed4ae44"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"slideInUp"}'
                    data-widget_type="image.default"
                  >
                    <div class="elementor-widget-container">
                      <img
                        v-if="randomGallerySlots[0]"
                        :src="getGalleryImageUrl(randomGallerySlots[0])"
                        loading="lazy"
                        decoding="async"
                        width="900"
                        height="600"
                        class="attachment-large size-large wp-image-49925 entered litespeed-loaded"
                        alt=""
                        style="width:100%; height:100%; object-fit:cover;"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-5e78bd0e e-con-full e-flex e-con e-child"
                  data-id="5e78bd0e"
                  data-element_type="container"
                  data-e-type="container"
                >
                  <div
                    class="elementor-element elementor-element-6e217653 elementor-widget elementor-widget-image animated slideInUp"
                    data-id="6e217653"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"slideInUp"}'
                    data-widget_type="image.default"
                  >
                    <div class="elementor-widget-container">
                      <img
                        v-if="randomGallerySlots[1]"
                        :src="getGalleryImageUrl(randomGallerySlots[1])"
                        loading="lazy"
                        decoding="async"
                        width="900"
                        height="600"
                        class="attachment-large size-large wp-image-49924 entered litespeed-loaded"
                        alt=""
                         style="width:100%; height:100%; object-fit:cover;"
                       />
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-ff078ac e-con-full e-flex e-con e-child"
                  data-id="ff078ac"
                  data-element_type="container"
                  data-e-type="container"
                >
                  <div
                    class="elementor-element elementor-element-751adad8 elementor-widget elementor-widget-image animated slideInUp"
                    data-id="751adad8"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"slideInUp"}'
                    data-widget_type="image.default"
                  >
                    <div class="elementor-widget-container">
                      <img
                        v-if="randomGallerySlots[2]"
                        :src="getGalleryImageUrl(randomGallerySlots[2])"
                        loading="lazy"
                        decoding="async"
                        width="900"
                        height="600"
                        class="attachment-large size-large wp-image-49926 entered litespeed-loaded"
                        alt=""
                        style="width:100%; height:100%; object-fit:cover;"
                      />
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-73a19bed e-con-full e-flex e-con e-child"
                    data-id="73a19bed"
                    data-element_type="container"
                    data-e-type="container"
                  >
                    <div
                      class="elementor-element elementor-element-637c2303 text-center elementor-widget elementor-widget-tp-advanced-typography animated zoomIn"
                      data-id="637c2303"
                      data-element_type="widget"
                      data-e-type="widget"
                      data-settings='{"_animation":"zoomIn"}'
                      data-widget_type="tp-advanced-typography.default"
                    >
                      <div class="elementor-widget-container">
                        <div id="at637c2303" class="pt-plus-adv-typo-wrapper">
                          <div class="pt_plus_adv_typo_block none">
                            <span id="advtypo6a12f5f19b4e9" class="text-content-block" style=""
                              >{{ namaPertama }} &amp; <br />{{ namaKedua }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-7e3947eb e-con-full e-flex e-con e-child"
              data-id="7e3947eb"
              data-element_type="container"
              data-e-type="container"
            >
              <div
                class="elementor-element elementor-element-230ebe45 elementor-widget elementor-widget-heading animated zoomIn"
                data-id="230ebe45"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"zoomIn"}'
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">THE DAY</h2>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-4e664957 elementor-widget__width-initial animated-slow elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="4e664957"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p>
                    {{ config.language === 1 ? 'It is an honor and happiness for us if you can attend and give your blessing to the bride and groom.' : 'Merupakan suatu kehormatan dan kebahagiaan bagi kami apabila Bapak/Ibu/Saudara/i dapat hadir dan memberikan doa restu kepada kedua mempelai.' }}
                  </p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-33ce5cdd elementor-countdown--label-block elementor-invisible elementor-widget"
                data-id="33ce5cdd"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"slideInUp"}'
              >
                <div class="elementor-widget-container">
                  <div class="elementor-countdown-wrapper" style="display:flex;flex-direction:row;flex-wrap:nowrap;gap:10px;">
                    <div class="elementor-countdown-item">
                      <span class="elementor-countdown-digits elementor-countdown-days">{{days}}</span>
                      <span class="elementor-countdown-label">{{config.language === 1 ? 'Days' : 'Hari'}}</span>
                    </div>
                    <div class="elementor-countdown-item">
                      <span class="elementor-countdown-digits elementor-countdown-hours">{{hours}}</span>
                      <span class="elementor-countdown-label">{{config.language === 1 ? 'Hours' : 'Jam'}}</span>
                    </div>
                    <div class="elementor-countdown-item">
                      <span class="elementor-countdown-digits elementor-countdown-minutes">{{minutes}}</span>
                      <span class="elementor-countdown-label">{{config.language === 1 ? 'Minutes' : 'Menit'}}</span>
                    </div>
                    <div class="elementor-countdown-item">
                      <span class="elementor-countdown-digits elementor-countdown-seconds">{{seconds}}</span>
                      <span class="elementor-countdown-label">{{config.language === 1 ? 'Seconds' : 'Detik'}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-29a138d9 e-con-full e-flex e-con e-child _mPS2id-t"
            data-id="29a138d9"
            data-element_type="container"
            data-e-type="container"
            id="mempelai"
          >
            <div
              class="elementor-element elementor-element-66d71b68 elementor-widget-divider--view-line_icon elementor-widget-divider--element-align-left elementor-view-default elementor-invisible elementor-widget elementor-widget-divider"
              data-id="66d71b68"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"fadeInUp"}'
              data-widget_type="divider.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-divider">
                  <span class="elementor-divider-separator">
                    <div class="elementor-icon elementor-divider__element">
                      <svg
                        aria-hidden="true"
                        class="e-font-icon-svg e-fas-quote-left"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                        ></path>
                      </svg>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-6391e229 elementor-invisible elementor-widget elementor-widget-heading"
              data-id="6391e229"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"fadeInUp"}'
              data-widget_type="heading.default"
            >
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">COUPLE</h2>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-54799f04 elementor-widget__width-initial animated-slow elementor-invisible elementor-widget elementor-widget-text-editor"
              data-id="54799f04"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"fadeInUp"}'
              data-widget_type="text-editor.default"
            >
              <div class="elementor-widget-container">
                <p>
                  Maha Suci Allah yang telah menciptakan makhluk-Nya berpasang-pasangan. Ya Allah semoga ridho-Mu
                  tercurah mengiringi pernikahan kami.
                </p>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-379ae2f e-con-full e-flex e-con e-child"
            data-id="379ae2f"
            data-element_type="container"
            data-e-type="container"
          >
            <div
              class="elementor-element elementor-element-1b298fec e-con-full e-flex elementor-invisible e-con e-child"
              data-id="1b298fec"
              data-element_type="container"
              data-e-type="container"
              data-settings='{"animation":"zoomIn"}'
              style="position: relative;"
            >
              <!-- SINGLE STATIC BACKGROUND IMAGE -->
              <div class="elementor-background-overlay"></div>
              <div class="elementor-background-slideshow" style="display: block; position: absolute; inset: 0; width: 100%; height: 100%;">
                <div
                  class="elementor-background-slideshow__slide__image"
                  :style="{ backgroundImage: 'url(' + getBridePhotoUrl() + ')', backgroundSize: 'cover', backgroundPosition: 'center center', width: '100%', height: '100%' }"
                ></div>
              </div>
              <div
                class="elementor-element elementor-element-386e9073 e-con-full e-flex e-con e-child"
                data-id="386e9073"
                data-element_type="container"
                data-e-type="container"
              >
                <div
                  class="elementor-element elementor-element-6f84f461 elementor-widget elementor-widget-spacer"
                  data-id="6f84f461"
                  data-element_type="widget"
                  data-e-type="widget"
                  data-widget_type="spacer.default"
                >
                  <div class="elementor-widget-container">
                    <div class="elementor-spacer">
                      <div class="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-3a50d4a4 text-center elementor-invisible elementor-widget elementor-widget-tp-advanced-typography"
                data-id="3a50d4a4"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"zoomIn"}'
                data-widget_type="tp-advanced-typography.default"
              >
                <div class="elementor-widget-container">
                  <div id="at3a50d4a4" class="pt-plus-adv-typo-wrapper">
                    <div class="pt_plus_adv_typo_block none">
                      <span id="advtypo6a12f5f1a0654" class="text-content-block" style="">{{ client.hajat === 'wanita' ? 'The Bride' : 'The Groom' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-48dbe27c e-con-full e-flex elementor-invisible e-con e-child"
              data-id="48dbe27c"
              data-element_type="container"
              data-e-type="container"
              data-settings='{"animation":"fadeInUp"}'
            >
              <div
                class="elementor-element elementor-element-6639bb9d animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="6639bb9d"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p>{{ client.hajat === 'wanita' ? client.nama_wanita : client.nama_pria }}</p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-15698e47 animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="15698e47"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p>{{ config.language === 1 ? (client.hajat === 'wanita' ? 'Daughter of :' : 'Son of :') : (client.hajat === 'wanita' ? 'Putri dari :' : 'Putra dari :') }}<br />{{ client.hajat === 'wanita' ? client.nama_ayah_wanita : client.nama_ayah_pria }}<br />
                    &amp;<br />
                    {{ client.hajat === 'wanita' ? client.nama_ibu_wanita : client.nama_ibu_pria }}</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-6db0b007 e-flex e-con-boxed e-con e-child"
            data-id="6db0b007"
            data-element_type="container"
            data-e-type="container"
          >
            <div class="e-con-inner">
              <div
                class="elementor-element elementor-element-3560d48a elementor-widget-divider--view-line_text elementor-widget-divider--element-align-center elementor-invisible elementor-widget elementor-widget-divider"
                data-id="3560d48a"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"zoomIn"}'
                data-widget_type="divider.default"
              >
                <div class="elementor-widget-container">
                  <div class="elementor-divider">
                    <span class="elementor-divider-separator">
                      <span class="elementor-divider__text elementor-divider__element"> and </span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-78bb5b86 e-con-full e-flex e-con e-child"
                data-id="78bb5b86"
                data-element_type="container"
                data-e-type="container"
              >
                <div
                  class="elementor-element elementor-element-16e61dee e-con-full e-flex elementor-invisible e-con e-child"
                  data-id="16e61dee"
                  data-element_type="container"
                  data-e-type="container"
                  data-settings='{"animation":"zoomIn"}'
                  style="position: relative;"
                >
                  <div class="elementor-background-overlay"></div>
                  <div class="elementor-background-slideshow" style="display: block; position: absolute; inset: 0; width: 100%; height: 100%;">
                    <div
                      class="elementor-background-slideshow__slide__image"
                      :style="{ backgroundImage: 'url(' + getGroomPhotoUrl() + ')', backgroundSize: 'cover', backgroundPosition: 'center center', width: '100%', height: '100%' }"
                    ></div>
                  </div>
                  <div
                    class="elementor-element elementor-element-4806a208 e-con-full e-flex e-con e-child"
                    data-id="4806a208"
                    data-element_type="container"
                    data-e-type="container"
                  >
                    <div
                      class="elementor-element elementor-element-5d18407f elementor-widget elementor-widget-spacer"
                      data-id="5d18407f"
                      data-element_type="widget"
                      data-e-type="widget"
                      data-widget_type="spacer.default"
                    >
                      <div class="elementor-widget-container">
                        <div class="elementor-spacer">
                          <div class="elementor-spacer-inner"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-3bea9bd6 text-center elementor-invisible elementor-widget elementor-widget-tp-advanced-typography"
                  data-id="3bea9bd6"
                  data-element_type="widget"
                  data-e-type="widget"
                  data-settings='{"_animation":"zoomIn"}'
                  data-widget_type="tp-advanced-typography.default"
                >
                  <div class="elementor-widget-container">
                    <div id="at3bea9bd6" class="pt-plus-adv-typo-wrapper">
                      <div class="pt_plus_adv_typo_block none">
                        <span id="advtypo6a12f5f1a2593" class="text-content-block" style="">{{ client.hajat === 'wanita' ? 'The Groom' : 'The Bride' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-1be73c65 e-con-full e-flex elementor-invisible e-con e-child"
                  data-id="1be73c65"
                  data-element_type="container"
                  data-e-type="container"
                  data-settings='{"animation":"fadeInUp"}'
                >
                  <div
                    class="elementor-element elementor-element-4a1c52e9 animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                    data-id="4a1c52e9"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"fadeInUp"}'
                    data-widget_type="text-editor.default"
                  >
                    <div class="elementor-widget-container">
                      <p>{{ client.hajat === 'wanita' ? client.nama_pria : client.nama_wanita }}</p>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-23fca0b3 animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                    data-id="23fca0b3"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"fadeInUp"}'
                    data-widget_type="text-editor.default"
                  >
                    <div class="elementor-widget-container">
                      <p>{{ config.language === 1 ? (client.hajat === 'wanita' ? 'Son of :' : 'Daughter of :') : (client.hajat === 'wanita' ? 'Putra dari :' : 'Putri dari :') }}<br />{{ client.hajat === 'wanita' ? client.nama_ayah_pria : client.nama_ayah_wanita }}<br />
                        &amp;<br />
                        {{ client.hajat === 'wanita' ? client.nama_ibu_pria : client.nama_ibu_wanita }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-62089506 e-con-full e-flex e-con e-child _mPS2id-t"
            data-id="62089506"
            data-element_type="container"
            data-e-type="container"
            id="event"
            data-settings='{"background_background":"classic"}'
          >
            <div
              class="elementor-element elementor-element-7c80a1c elementor-widget__width-initial animated-slow elementor-invisible elementor-widget elementor-widget-text-editor"
              data-id="7c80a1c"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"fadeInUp"}'
              data-widget_type="text-editor.default"
            >
              <div class="elementor-widget-container">
                <p v-html="client.quote">                  
                </p>
                <p>— {{ client.title_quote }}</p>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-65df79b7 elementor-view-default elementor-invisible elementor-widget elementor-widget-icon"
              data-id="65df79b7"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"zoomIn"}'
              data-widget_type="icon.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-wrapper">
                  <div class="elementor-icon">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-fas-quote-left"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-7243e77a elementor-invisible elementor-widget elementor-widget-heading"
              data-id="7243e77a"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"zoomIn"}'
              data-widget_type="heading.default"
            >
              <div class="elementor-widget-container">
                <h2 class="elementor-heading-title elementor-size-default">WEDDING EVENT</h2>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-5f788761 e-con-full e-flex elementor-invisible e-con e-child"
              data-id="5f788761"
              data-element_type="container"
              data-e-type="container"
              data-settings='{"animation":"fadeInUp"}'
            >
              <div
                class="elementor-element elementor-element-3a292512 e-con-full e-flex e-con e-child"
                data-id="3a292512"
                data-element_type="container"
                data-e-type="container"
                data-settings='{"background_background":"classic"}'
                :style="{ backgroundImage: 'url(' + (randomGallerySlots[4] ? getGalleryImageUrl(randomGallerySlots[4]) : '') + ')', backgroundSize: 'cover', backgroundPosition: 'center center' }"
              >
                <div
                  class="elementor-element elementor-element-318eb696 elementor-widget elementor-widget-spacer"
                  data-id="318eb696"
                  data-element_type="widget"
                  data-e-type="widget"
                  data-widget_type="spacer.default"
                >
                  <div class="elementor-widget-container">
                    <div class="elementor-spacer">
                      <div class="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-26aba016 elementor-align-justify elementor-mobile-align-justify animated-slow elementor-invisible elementor-widget elementor-widget-weddingpress-datekit"
                data-id="26aba016"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"zoomIn"}'
                data-widget_type="weddingpress-datekit.default"
              >
                <div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <a
                      :href="generateCalendarLink()"
                      class="elementor-button-link elementor-button elementor-size-sm"
                      target="_blank"
                      rel="nofollow"
                      role="button"
                    >
                      <span class="elementor-button-content-wrapper wdp-flexbox">
                        <span class="elementor-button-text">Save the Date</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-3268fd58 e-con-full e-flex e-con e-child"
              data-id="3268fd58"
              data-element_type="container"
              data-e-type="container"
            >
              <div
                class="elementor-element elementor-element-6c981b15 elementor-widget-divider--view-line_text elementor-widget-divider--element-align-center elementor-invisible elementor-widget elementor-widget-divider"
                data-id="6c981b15"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="divider.default"
              >
                <div class="elementor-widget-container">
                  <div class="elementor-divider">
                    <span class="elementor-divider-separator">
                      <span class="elementor-divider__text elementor-divider__element"> AKAD NIKAH </span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-4f6cbea2 animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="4f6cbea2"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p>{{ moment(client.tgl_akad).locale(config.language === 1 ? 'en' : 'id').format('dddd').toUpperCase() }},<br />{{ moment(client.tgl_akad).locale(config.language === 1 ? 'en' : 'id').format('DD MMMM YYYY').toUpperCase() }}</p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-3065364e animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="3065364e"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p>Pukul 
                    <template v-if="client.tgl_akad_selesai == null">
                      {{ moment(client.tgl_akad).format("HH:mm") }} - Selesai
                    </template>
                    <template v-else>
                      {{ moment(client.tgl_akad).format("HH:mm") }} - {{ moment(client.tgl_akad_selesai).format("HH:mm") }}
                    </template>
                  </p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-7a74066b animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="7a74066b"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p><strong>{{ client.nama_venue }}</strong><br />{{ stripHtml(client.alamat_venue) }}</p>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-1623a3f1 e-con-full e-flex e-con e-child"
              data-id="1623a3f1"
              data-element_type="container"
              data-e-type="container"
            >
              <div
                class="elementor-element elementor-element-380c3c24 elementor-widget-divider--view-line_text elementor-widget-divider--element-align-center elementor-invisible elementor-widget elementor-widget-divider"
                data-id="380c3c24"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="divider.default"
              >
                <div class="elementor-widget-container">
                  <div class="elementor-divider">
                    <span class="elementor-divider-separator">
                      <span class="elementor-divider__text elementor-divider__element"> {{config.language == 1 ? 'RECEPTION' : 'RESEPSI'}} </span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-40c37df9 animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="40c37df9"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p>{{ moment(client.tgl_resepsi).locale(config.language === 1 ? 'en' : 'id').format('dddd').toUpperCase() }},<br />{{ moment(client.tgl_resepsi).locale(config.language === 1 ? 'en' : 'id').format('DD MMMM YYYY').toUpperCase() }}</p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-46eb7b10 animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="46eb7b10"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p>
                    <template v-if="client.tgl_resepsi_selesai == null">
                      {{ moment(client.tgl_resepsi).format("HH:mm") }} - Selesai
                    </template>
                    <template v-else>
                      {{ moment(client.tgl_resepsi).format("HH:mm") }} - {{ moment(client.tgl_resepsi_selesai).format("HH:mm") }}
                    </template>
                  </p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-14941b5d animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="14941b5d"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p><strong>{{ client.nama_venue_resepsi }}</strong><br />{{ stripHtml(client.alamat_venue_resepsi) }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- Maps Section -->
          <div
            v-if="config.maps_section !== 0 && client.embed"
            class="elementor-element e-con-full e-flex e-con e-child"
            style="padding: 0; background: #fff; position: relative;"
          >
            <!-- Top separator -->
            <div style="width:100%; height:1px; background: #D2D2D2;"></div>

            <!-- Section Header -->
            <div data-sa style="text-align:center; padding: 36px 24px 16px;">
              <svg viewBox="0 0 384 512" style="width:22px; height:22px; fill:#333435; display:block; margin: 0 auto 10px;">
                <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"/>
              </svg>
              <h2 style="font-family:'Cormorant Infant',serif; font-size:26px; letter-spacing:5px; color:#1B1B1B; font-weight:400; margin:0 0 10px; text-transform:uppercase;">
                {{ config.language === 1 ? 'Maps Location' : 'Lokasi Acara' }}
              </h2>
              <div style="width:40px; height:1px; background:#414141; margin:0 auto;"></div>
            </div>

            <!-- Iframe Map -->
            <div data-sa="zoom" style="width:100%; padding: 0 20px; box-sizing:border-box;">
              <div style="border-radius:14px; overflow:hidden; box-shadow: 0 10px 40px rgba(0,0,0,0.13), 0 2px 8px rgba(0,0,0,0.07);">
                <iframe
                  :src="client.embed"
                  width="100%"
                  height="380"
                  style="border:0; display:block;"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            <!-- Button -->
            <div data-sa style="text-align:center; padding: 24px 20px 36px; transition-delay: 0.15s;">
              <a
                :href="client.url_maps"
                target="_blank"
                rel="noopener noreferrer"
                style="display:inline-flex; align-items:center; gap:10px; padding:13px 36px; background:#333435; color:#FFF; text-decoration:none; letter-spacing:3px; font-size:11px; font-family:'Cormorant Infant',serif; border-radius:2px; transition:background 0.3s;"
                onmouseover="this.style.background='#5E5D5D'"
                onmouseout="this.style.background='#333435'"
              >
                <svg viewBox="0 0 384 512" style="width:12px; height:12px; fill:#FFF; flex-shrink:0;">
                  <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"/>
                </svg>
                {{ config.language === 1 ? 'OPEN MAPS' : 'BUKA MAPS' }}
              </a>
            </div>

            <!-- Bottom separator -->
            <div style="width:100%; height:1px; background: #D2D2D2;"></div>
          </div>
          <!-- End Maps Section -->
          <!-- Love Story Section (Dynamic Timeline) -->
          <div
            v-if="config.story_section === 1 && guest.story && guest.story.length > 0"
            class="elementor-element e-con-full e-flex e-con e-child"
            style="padding: 0; background: #fff; position: relative;"
          >
            <!-- Top separator -->
            <div style="width:100%; height:1px; background: #D2D2D2;"></div>

            <!-- Section Header -->
            <div data-sa style="text-align:center; padding: 40px 24px 20px;">
              <!-- Heart icon -->
              <svg viewBox="0 0 24 24" style="width:22px; height:22px; fill:#333435; display:block; margin: 0 auto 10px;" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
              <h2 style="font-family:'Cormorant Infant',serif; font-size:26px; letter-spacing:5px; color:#1B1B1B; font-weight:400; margin:0 0 10px; text-transform:uppercase;">
                {{ config.language === 1 ? 'Love Story' : 'Love Story' }}
              </h2>
              <div style="width:40px; height:1px; background:#414141; margin:0 auto;"></div>
            </div>

            <!-- Timeline -->
            <div style="padding: 10px 20px 40px; position:relative; box-sizing:border-box;">
              <!-- Vertical line -->
              <div style="position:absolute; left:38px; top:0; bottom:0; width:1px; background:#D2D2D2;"></div>

              <!-- Story items -->
              <div
                v-for="(item, index) in guest.story"
                :key="item.id"
                data-sa
                :style="{ position:'relative', paddingLeft:'52px', marginBottom:'28px', transitionDelay: `${index * 120}ms` }"
              >
                <!-- Step number dot -->
                <div style="position:absolute; left:26px; top:16px; width:24px; height:24px; background:#333435; border-radius:50%; border:2px solid #fff; box-shadow:0 0 0 2px #333435; display:flex; align-items:center; justify-content:center; z-index:1;">
                  <span style="font-family:'Cormorant Infant',serif; font-size:11px; color:#fff; font-weight:600; line-height:1;">{{ index + 1 }}</span>
                </div>

                <!-- Card -->
                <div style="background:#F2F2F2; border-radius:10px; padding:16px 18px; box-shadow:0 2px 8px rgba(0,0,0,0.05);">
                  <!-- Title -->
                  <h3 style="font-family:'Cormorant Infant',serif; font-size:18px; color:#1B1B1B; margin:0 0 4px; font-weight:600; letter-spacing:1px;">
                    {{ item.title }}
                  </h3>
                  <!-- Range time -->
                  <p v-if="item.rangeTime" style="font-family:'Cormorant Infant',serif; font-size:12px; color:#7D7B7BC2; margin:0 0 10px; font-style:italic; letter-spacing:0.5px;">
                    📍 {{ item.rangeTime }}
                  </p>
                  <!-- Photo -->
                  <div v-if="item.media && item.type === 'foto'" style="margin-bottom:12px; border-radius:8px; overflow:hidden;">
                    <img
                      :src="`https://admin.itsyourdayofficial.com/story/${item.media}`"
                      :alt="item.title"
                      loading="lazy"
                      style="width:100%; display:block; object-fit:cover; max-height:260px;"
                    />
                  </div>
                  <!-- Description -->
                  <div
                    v-html="item.description"
                    style="font-family:'Cormorant Infant',serif; font-size:15px; color:#403E3E; line-height:1.75; margin:0;"
                  ></div>
                </div>
              </div>
            </div>

            <!-- Bottom separator -->
            <div style="width:100%; height:1px; background: #D2D2D2;"></div>
          </div>
          <!-- End Love Story Section -->
          <div
            class="elementor-element elementor-element-38111ddf e-con-full e-flex e-con e-child"
            data-id="38111ddf"
            data-element_type="container"
            data-e-type="container"
            data-settings='{"background_background":"classic"}'
            :style="{ backgroundImage: 'url(' + (randomGallerySlots[8] ? getGalleryImageUrl(randomGallerySlots[8]) : '') + ')', backgroundSize: 'cover', backgroundPosition: 'center center' }"
          >
            <div
              class="elementor-element elementor-element-3ce3bb8e e-con-full e-flex elementor-invisible e-con e-child"
              data-id="3ce3bb8e"
              data-element_type="container"
              data-e-type="container"
              data-settings='{"animation":"zoomIn"}'
            >
              <div
                class="elementor-element elementor-element-10205b9 animated-slow elementor-invisible elementor-widget elementor-widget-heading"
                data-id="10205b9"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">RSVP by WhatsApp</h2>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-7bd43dbc animated-slow elementor-invisible elementor-widget elementor-widget-text-editor"
                data-id="7bd43dbc"
                data-element_type="widget"
                data-e-type="widget"
                data-settings='{"_animation":"fadeInUp"}'
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <p v-html="confirmationText"></p>
                </div>  
              </div>
              <div
                class="elementor-element elementor-element-1de9f2 elementor-button-align-stretch elementor-widget"
                data-id="1de9f2"
                data-element_type="widget"
                data-e-type="widget"
              >
                <div class="elementor-widget-container">
                  <form class="elementor-form" name="New Form" aria-label="New Form" @submit.prevent.stop="handleSubmit">

                    <div class="elementor-form-fields-wrapper elementor-labels-above">
                      <div
                        class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-100 elementor-field-required"
                      >
                        <label for="form-field-name" class="elementor-field-label"> Nama </label>
                        <input
                          size="1"
                          type="text"
                          name="form_fields[name]"
                          id="form-field-name"
                          class="elementor-field elementor-size-xs elementor-field-textual"
                          placeholder="Nama"
                          required="required"
                          v-model="name"
                          autocomplete="false"
                        />
                      </div>
                      <div
                        class="elementor-field-type-select elementor-field-group elementor-column elementor-field-group-message elementor-col-100 elementor-sm-100 elementor-field-required"
                      >
                        <label for="form-field-message" class="elementor-field-label"> Kehadiran </label>
                        <div class="elementor-field elementor-select-wrapper remove-before">
                          <div class="select-caret-down-wrapper">
                            <svg
                              aria-hidden="true"
                              class="e-font-icon-svg e-eicon-caret-down"
                              viewBox="0 0 571.4 571.4"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M571 393Q571 407 561 418L311 668Q300 679 286 679T261 668L11 418Q0 407 0 393T11 368 36 357H536Q550 357 561 368T571 393Z"
                              ></path>
                            </svg>
                          </div>
                           <select
                            name="form_fields[message]"
                            id="form-field-message"
                            class="elementor-field-textual elementor-size-xs"
                            required="required"
                            v-model="picked"
                          >
                            <option :value="config.language === 1 ? 'Yes, I would love to attend' : 'Iya, Saya akan Hadir'">
                              {{ config.language === 1 ? 'Yes, I will attend' : 'Iya, Saya akan Hadir' }}
                            </option>
                            <option :value="config.language === 1 ? 'Sorry, I cant attend' : 'Maaf, Saya Tidak Bisa Hadir'">
                              {{ config.language === 1 ? 'Sorry, I cant attend' : 'Maaf, Saya Tidak Bisa Hadir' }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div
                        v-if="picked === 'Iya, Saya akan Hadir' || picked === 'Yes, I would love to attend'"
                        class="elementor-field-type-select elementor-field-group elementor-column elementor-field-group-field_1427e41 elementor-col-100 elementor-sm-100"
                      >
                        <label for="form-field-field_1427e41" class="elementor-field-label"> Jumlah </label>
                        <div class="elementor-field elementor-select-wrapper remove-before">
                          <div class="select-caret-down-wrapper">
                            <svg aria-hidden="true" class="e-font-icon-svg e-eicon-caret-down" viewBox="0 0 571.4 571.4" xmlns="http://www.w3.org/2000/svg">
                              <path d="M571 393Q571 407 561 418L311 668Q300 679 286 679T261 668L11 418Q0 407 0 393T11 368 36 357H536Q550 357 561 368T571 393Z"></path>
                            </svg>
                          </div>
                          <select
                            name="form_fields[field_1427e41]"
                            id="form-field-field_1427e41"
                            class="elementor-field-textual elementor-size-xs"
                            required="required"
                            v-model="jumlah"
                          >
                            <option value="1 Orang">{{ config.language === 1 ? '1 Person' : '1 Orang' }}</option>
                            <option value="2 Orang">{{ config.language === 1 ? '2 People' : '2 Orang' }}</option>
                          </select>
                        </div>
                      </div>
                      <div
                        class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons"
                      >
                        <button class="elementor-button elementor-size-sm elementor-animation-grow" type="submit">
                          <span class="elementor-button-content-wrapper">
                            <span class="elementor-button-text">Konfirmasi</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-54a74291 e-con-full e-flex e-con e-child"
            data-id="54a74291"
            data-element_type="container"
            data-e-type="container"
          >
            <div
              class="elementor-element elementor-element-750011fc elementor-view-default elementor-invisible elementor-widget elementor-widget-icon"
              data-id="750011fc"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"zoomIn"}'
              data-widget_type="icon.default"
            >
              <div class="elementor-widget-container">
                <div class="elementor-icon-wrapper">
                  <div class="elementor-icon">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-fas-quote-left"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-element elementor-element-41a5fb08 elementor-widget__width-initial animated-slow elementor-invisible elementor-widget elementor-widget-text-editor"
              data-id="41a5fb08"
              data-element_type="widget"
              data-e-type="widget"
              data-settings='{"_animation":"fadeInUp"}'
              data-widget_type="text-editor.default"
            >
              <div class="elementor-widget-container">
                <p>
                  “When you realize you want to spend the rest of your life with somebody, you want the rest of your
                  life to start as soon as possible.”
                </p>
                <p>— Nora Ephron</p>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-4a9698fb e-flex e-con-boxed e-con e-child"
            data-id="4a9698fb"
            data-element_type="container"
            data-e-type="container"
          >
            <div class="e-con-inner">
              <div
                class="elementor-element elementor-element-468b9824 e-con-full e-flex e-con e-child"
                data-id="468b9824"
                data-element_type="container"
                data-e-type="container"
                id="wishes"
              >
                <div
                  class="elementor-element elementor-element-21b3391 e-con-full e-flex e-con e-child"
                  data-id="21b3391"
                  data-element_type="container"
                  data-e-type="container"
                  data-settings='{"background_background":"classic"}'
                >
                  <div
                    class="elementor-element elementor-element-6d2cfcc4 e-con-full e-flex e-con e-child"
                    data-id="6d2cfcc4"
                    data-element_type="container"
                    data-e-type="container"
                  >
                    <div
                      class="elementor-element elementor-element-520917b5 e-con-full e-flex e-con e-child"
                      data-id="520917b5"
                      data-element_type="container"
                      data-e-type="container"
                    >
                      <div
                        class="elementor-element elementor-element-6ac44288 elementor-invisible elementor-widget elementor-widget-image"
                        data-id="6ac44288"
                        data-element_type="widget"
                        data-e-type="widget"
                        data-settings='{"_animation":"zoomIn"}'
                        data-widget_type="image.default"
                      >
                        <div class="elementor-widget-container">
                           <img
                             :src="randomGallerySlots[3] ? getGalleryImageUrl(randomGallerySlots[3]) : 'assets/wp-content/uploads/2024/06/CHO09868-1200x800.jpg'"
                             loading="lazy"
                             decoding="async"
                             width="900"
                             height="600"
                             class="attachment-large size-large wp-image-51707"
                             alt=""
                             style="width:100%; height:auto; object-fit:cover;"
                           />
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-58057d12 e-con-full e-flex e-con e-child"
                        data-id="58057d12"
                        data-element_type="container"
                        data-e-type="container"
                      >
                        <div
                          class="elementor-element elementor-element-37142907 elementor-invisible elementor-widget elementor-widget-heading"
                          data-id="37142907"
                          data-element_type="widget"
                          data-e-type="widget"
                          data-settings='{"_animation":"fadeInUp"}'
                          data-widget_type="heading.default"
                        >
                          <div class="elementor-widget-container">
                            <h2 class="elementor-heading-title elementor-size-default">WEDDING WISHES</h2>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-74095b23 elementor-widget__width-initial animated-slow elementor-invisible elementor-widget elementor-widget-text-editor"
                          data-id="74095b23"
                          data-element_type="widget"
                          data-e-type="widget"
                          data-settings='{"_animation":"fadeInUp"}'
                          data-widget_type="text-editor.default"
                        >
                          <div class="elementor-widget-container">
                            <p>Silakan tuliskan ucapan selamat dan doa terbaik Anda pada form di bawah ini.</p>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-f9824ea animated-slow elementor-invisible elementor-widget elementor-widget-weddingpress-commentkit"
                          data-id="f9824ea"
                          data-element_type="widget"
                          data-e-type="widget"
                          data-settings='{"_animation":"zoomIn","show_date":"yes"}'
                          data-widget_type="weddingpress-commentkit.default"
                        >
                          <div class="elementor-widget-container">
                            <div class="wdp-wrapper wdp-golden wdp-border wdp-full" style="overflow: hidden">
                              <div class="wdp-wrap-link">
                                <!-- Counter: pakai class neutral agar WDP JS tidak intercept -->
                                <a
                                  class="vue-wishes-link"
                                  href="#wedding-wishes"
                                  style="font-size:1em;font-weight:700;color:#3d7dbc;text-decoration:none;font-family:inherit;"
                                ><i aria-hidden="true" class="fas fa-dove"> </i> <span>{{ hopesCount }}</span> {{ config.language === 1 ? 'Comments' : 'Ucapan' }}</a>
                              </div>
                              <!--.wdp-wrap-link-->
                              <div id="wdp-wrap-commnent-49887" class="wdp-wrap-comments" style="display: block">
                                <div id="wdp-wrap-form-49887" class="wdp-wrap-form wdp-clearfix" style="display: block">
                                  <div id="wdp-container-form-49887" class="wdp-container-form wdp-no-login">
                                    <div id="respond-49887" class="respond wdp-clearfix">
                                      <form @submit.prevent="handleWishPost" id="vue-wishes-form">
                                        <p class="comment-form-author wdp-field-1">
                                          <input
                                            id="author"
                                            name="author"
                                            type="text"
                                            aria-required="true"
                                            class="wdp-input"
                                            placeholder="Nama"
                                            v-model="submit.name"
                                            required="required"
                                          /><span class="wdp-required">*</span>
                                          <span v-if="errors.name" class="wdp-error-info wdp-error-info-name" style="display: block">
                                            {{ config.language === 1 ? "Please input your name" : 'Silahkan tulis nama anda' }}
                                          </span>
                                        </p>
                                        <div class="wdp-wrap-textarea">
                                          <textarea
                                            id="wdp-textarea-49887"
                                            class="waci_comment wdp-textarea autosize-textarea"
                                            name="comment"
                                            aria-required="true"
                                            placeholder="Ucapan"
                                            rows="3"
                                            style="
                                              overflow: hidden;
                                              overflow-wrap: break-word;
                                              resize: none;
                                              height: 70px;
                                            "
                                            v-model="submit.comment"
                                            required="required"
                                          ></textarea>
                                          <div class="charleft wdp-counter-info">&nbsp;</div>
                                          <span class="wdp-required">*</span>
                                          <span v-if="errors.comment" class="wdp-error-info wdp-error-info-text" style="display: block">
                                            {{ config.language === 1 ? "Please write a comment" : "Tolong tulis ucapan Anda" }}
                                          </span>
                                        </div>

                                        <div class="wdp-wrap-select">
                                          <select class="waci_comment wdp-select" name="konfirmasi" v-model="submit.confirmation" required="required">
                                            <option value="" disabled selected>{{ config.language === 1 ? "Select Confirm Attendance" : 'Pilih Konfirmasi Kehadiran' }}</option>
                                            <option value="hadir">{{ config.language === 1 ? "Attending" : 'Hadir' }}</option>
                                            <option value="tidak">{{ config.language === 1 ? "Not Attending" : 'Tidak Hadir' }}</option>
                                          </select>
                                          <span class="wdp-required">*</span>
                                          <span v-if="errors.confirmation" class="wdp-error-info wdp-error-info-confirm" style="display: block">
                                            {{ config.language === 1 ? "Please confirm your attendance" : 'Harap pilih konfirmasi kehadiran anda' }}
                                          </span>
                                        </div>
                                        <div class="wdp-wrap-submit wdp-clearfix">
                                          <p class="form-submit">
                                            <button
                                              name="submit"
                                              id="submit-49887"
                                              type="submit"
                                              :disabled="isSubmittingWish"
                                              style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; transition: opacity 0.3s;"
                                              :style="isSubmittingWish ? 'opacity: 0.7; cursor: not-allowed;' : ''"
                                            >
                                              <span v-if="isSubmittingWish" class="wish-spinner"></span>
                                              <span>{{ isSubmittingWish ? (config.language === 1 ? 'Sending...' : 'Mengirim...') : (config.language === 1 ? 'Send' : 'Kirim') }}</span>
                                            </button>
                                          </p>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                  <!--.wdp-container-form-->
                                </div>
                                <!--.wdp-wrap-form-->
                                <div
                                  id="wdp-comment-status-49887"
                                  class="wdp-comment-status"
                                  style="display: none !important"
                                ></div>
                                <ul
                                  id="wdp-container-comment-49887"
                                  class="wdp-container-comments wdp-order-DESC wdp-has-2-comments wdp-multiple-comments"
                                  data-order="DESC"
                                  style="display: block"
                                >
                                  <li
                                    class="comment even thread-even depth-1 wdp-item-comment"
                                    v-for="h in hopes"
                                    :key="h.id"
                                  >
                                    <div :id="`wdp-comment-${h.id}`" class="wdp-comment wdp-clearfix">
                                      <div class="wdp-comment-avatar">
                                        <img src="assets/wp-content/plugins/weddingpress/assets/images/wdp-icon.png" />
                                      </div>
                                      <!--.wdp-comment-avatar-->

                                      <div class="wdp-comment-content">
                                        <div class="wdp-comment-info">
                                          <a class="wdp-commenter-name" :title="h.name">{{ h.name }}</a>

                                          <span v-if="h.confirmation" class="wdp-post-author">
                                            <i v-if="h.confirmation == 'hadir'" class="fas fa-check-circle" style="color: #28a745; margin-left: 5px;" title="Hadir"></i>
                                            <i v-else class="fas fa-times-circle" style="color: #dc3545; margin-left: 5px;" title="Tidak Hadir"></i>
                                          </span>
                                          <br />

                                          <span class="wdp-comment-time">
                                            <i class="far fa-clock"></i>
                                            {{ getElapsedTime(h.created_at) }}
                                          </span>
                                        </div>
                                        <!--.wdp-comment-info-->

                                        <div class="wdp-comment-text">
                                          <p v-html="h.comment"></p>
                                        </div>
                                        <!--.wdp-comment-text-->
                                      </div>
                                      <!--.wdp-comment-content-->
                                    </div>
                                    <!--.wdp-comment-->
                                  </li>
                                </ul>
                                <div id="wdp-holder-49887" class="wdp-holder-49887 wdp-holder"></div>
                                <div id="snackbar" v-if="snackbar" style="margin-top: 15px;">
                                  {{ config.language === 1 ? 'Your wishes have been sent, thank you.' : messageSnackBar }}
                                </div>
                              </div>
                              <!--.wdp-wrap-comments-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-5272b97b e-con-full e-flex e-con e-child _mPS2id-t"
                data-id="5272b97b"
                data-element_type="container"
                data-e-type="container"
                id="kado"
              >
                <div
                  class="elementor-element elementor-element-1f3e2a12 animated-slow elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="1f3e2a12"
                  data-element_type="widget"
                  data-e-type="widget"
                  data-settings='{"_animation":"fadeInUp"}'
                  data-widget_type="heading.default"
                >
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">WEDDING GIFT</h2>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-21c3bc2a e-grid e-con-full elementor-invisible e-con e-child"
                  data-id="21c3bc2a"
                  data-element_type="container"
                  data-e-type="container"
                  data-settings='{"animation":"fadeInUp"}'
                >
                  <div
                    class="elementor-element elementor-element-7dc4f65f e-con-full e-flex e-con e-child"
                    data-id="7dc4f65f"
                    data-element_type="container"
                    data-e-type="container"
                    data-settings='{"background_background":"classic"}'
                    :style="{ backgroundImage: 'url(' + (randomGallerySlots[5] ? getGalleryImageUrl(randomGallerySlots[5]) : '') + ')', backgroundSize: 'cover', backgroundPosition: 'center center' }"
                  >
                    <div
                      class="elementor-element elementor-element-62e5f4c0 elementor-widget elementor-widget-spacer"
                      data-id="62e5f4c0"
                      data-element_type="widget"
                      data-e-type="widget"
                      data-widget_type="spacer.default"
                    >
                      <div class="elementor-widget-container">
                        <div class="elementor-spacer">
                          <div class="elementor-spacer-inner"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-3bcad347 e-con-full e-flex e-con e-child"
                    data-id="3bcad347"
                    data-element_type="container"
                    data-e-type="container"
                    data-settings='{"background_background":"classic"}'
                    :style="{ backgroundImage: 'url(' + (randomGallerySlots[6] ? getGalleryImageUrl(randomGallerySlots[6]) : '') + ')', backgroundSize: 'cover', backgroundPosition: 'center center' }"
                  >
                    <div
                      class="elementor-element elementor-element-36091f4a elementor-widget elementor-widget-spacer"
                      data-id="36091f4a"
                      data-element_type="widget"
                      data-e-type="widget"
                      data-widget_type="spacer.default"
                    >
                      <div class="elementor-widget-container">
                        <div class="elementor-spacer">
                          <div class="elementor-spacer-inner"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-143f34a5 elementor-widget__width-initial animated-slow elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="143f34a5"
                  data-element_type="widget"
                  data-e-type="widget"
                  data-settings='{"_animation":"fadeInUp"}'
                  data-widget_type="heading.default"
                >
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">
                      Doa restu Anda merupakan karunia yang sangat berarti bagi kami.
                    </h2>
                  </div>
                </div>
                <!-- Wedding Gift Toggle Button - Vue Native -->
                <div style="width: 100%; margin-top: 12px;">
                  <button
                    id="btnAmplopVue"
                    onclick="window.__toggleAmplop && window.__toggleAmplop()"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 8px;
                      width: 100%;
                      padding: 12px 20px;
                      background: #1e1e1e;
                      color: #fff;
                      border: none;
                      border-radius: 4px;
                      font-size: 14px;
                      font-weight: 600;
                      letter-spacing: 1px;
                      cursor: pointer;
                    "
                  >
                    <svg aria-hidden="true" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style="width:16px;height:16px;fill:currentColor;">
                      <path d="M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"/>
                    </svg>
                    <span>Klik disini</span>
                  </button>
                </div>
                <div
                  class="elementor-element elementor-element-181a0495 e-con-full e-flex e-con e-child"
                  data-id="181a0495"
                  data-element_type="container"
                  data-e-type="container"
                  id="amplop"
                  style="display: none;"
                >
                  <!-- Bank Account 1 (always shown if exists) -->
                  <div v-if="client.no_acc" class="elementor-element e-flex e-con-boxed e-con e-child">
                    <div class="e-con-inner" style="display:flex; flex-direction:row; align-items:center; justify-content:space-between; flex-wrap:nowrap; gap:12px; padding: 12px 0; border-bottom: 1px solid #e0e0e0; width:100%;">
                      <div style="flex:1; min-width:0;">
                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:4px;">
                          <img v-if="getBankLogo(client.bank)" :src="getBankLogo(client.bank)" :alt="client.bank" style="height:24px; width:auto; object-fit:contain; flex-shrink:0;" />
                          <p style="margin:0; font-weight:600; font-size:14px;">{{ client.bank }}</p>
                        </div>
                        <p style="margin:0; font-size:13px; color:#555;">{{ client.no_acc }}<br/>a.n {{ client.acc_bank }}</p>
                      </div>
                      <div style="flex-shrink:0;">
                        <a
                          style="cursor: pointer; display:inline-flex; align-items:center; gap:6px; border:1px solid #ccc; border-radius:4px; padding:6px 12px; font-size:12px;"
                          class="elementor-button wdp-copy-btn"
                          role="button"
                          data-message="berhasil disalin"
                          :data-clipboard-text="client.no_acc"
                        >
                          <svg aria-hidden="true" class="e-font-icon-svg e-far-copy" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;">
                            <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
                          </svg>
                          <span>COPY</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Bank Account 2 (conditional) -->
                  <div v-if="client.no_acc2" class="elementor-element e-flex e-con-boxed e-con e-child">
                    <div class="e-con-inner" style="display:flex; flex-direction:row; align-items:center; justify-content:space-between; flex-wrap:nowrap; gap:12px; padding: 12px 0; border-bottom: 1px solid #e0e0e0; width:100%;">
                      <div style="flex:1; min-width:0;">
                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:4px;">
                          <img v-if="getBankLogo(client.bank2)" :src="getBankLogo(client.bank2)" :alt="client.bank2" style="height:24px; width:auto; object-fit:contain; flex-shrink:0;" />
                          <p style="margin:0; font-weight:600; font-size:14px;">{{ client.bank2 }}</p>
                        </div>
                        <p style="margin:0; font-size:13px; color:#555;">{{ client.no_acc2 }}<br/>a.n {{ client.acc_bank2 }}</p>
                      </div>
                      <div style="flex-shrink:0;">
                        <a
                          style="cursor: pointer; display:inline-flex; align-items:center; gap:6px; border:1px solid #ccc; border-radius:4px; padding:6px 12px; font-size:12px;"
                          class="elementor-button wdp-copy-btn"
                          role="button"
                          data-message="berhasil disalin"
                          :data-clipboard-text="client.no_acc2"
                        >
                          <svg aria-hidden="true" class="e-font-icon-svg e-far-copy" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;">
                            <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
                          </svg>
                          <span>COPY</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Bank Account 3 (conditional) -->
                  <div v-if="client.no_acc3" class="elementor-element e-flex e-con-boxed e-con e-child">
                    <div class="e-con-inner" style="display:flex; flex-direction:row; align-items:center; justify-content:space-between; flex-wrap:nowrap; gap:12px; padding: 12px 0; border-bottom: 1px solid #e0e0e0; width:100%;">
                      <div style="flex:1; min-width:0;">
                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:4px;">
                          <img v-if="getBankLogo(client.bank3)" :src="getBankLogo(client.bank3)" :alt="client.bank3" style="height:24px; width:auto; object-fit:contain; flex-shrink:0;" />
                          <p style="margin:0; font-weight:600; font-size:14px;">{{ client.bank3 }}</p>
                        </div>
                        <p style="margin:0; font-size:13px; color:#555;">{{ client.no_acc3 }}<br/>a.n {{ client.acc_bank3 }}</p>
                      </div>
                      <div style="flex-shrink:0;">
                        <a
                          style="cursor: pointer; display:inline-flex; align-items:center; gap:6px; border:1px solid #ccc; border-radius:4px; padding:6px 12px; font-size:12px;"
                          class="elementor-button wdp-copy-btn"
                          role="button"
                          data-message="berhasil disalin"
                          :data-clipboard-text="client.no_acc3"
                        >
                          <svg aria-hidden="true" class="e-font-icon-svg e-far-copy" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;">
                            <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
                          </svg>
                          <span>COPY</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Bank Account 4 (conditional) -->
                  <div v-if="client.no_acc4" class="elementor-element e-flex e-con-boxed e-con e-child">
                    <div class="e-con-inner" style="display:flex; flex-direction:row; align-items:center; justify-content:space-between; flex-wrap:nowrap; gap:12px; padding: 12px 0; border-bottom: 1px solid #e0e0e0; width:100%;">
                      <div style="flex:1; min-width:0;">
                        <div style="display:flex; align-items:center; gap:8px; margin-bottom:4px;">
                          <img v-if="getBankLogo(client.bank4)" :src="getBankLogo(client.bank4)" :alt="client.bank4" style="height:24px; width:auto; object-fit:contain; flex-shrink:0;" />
                          <p style="margin:0; font-weight:600; font-size:14px;">{{ client.bank4 }}</p>
                        </div>
                        <p style="margin:0; font-size:13px; color:#555;">{{ client.no_acc4 }}<br/>a.n {{ client.acc_bank4 }}</p>
                      </div>
                      <div style="flex-shrink:0;">
                        <a
                          style="cursor: pointer; display:inline-flex; align-items:center; gap:6px; border:1px solid #ccc; border-radius:4px; padding:6px 12px; font-size:12px;"
                          class="elementor-button wdp-copy-btn"
                          role="button"
                          data-message="berhasil disalin"
                          :data-clipboard-text="client.no_acc4"
                        >
                          <svg aria-hidden="true" class="e-font-icon-svg e-far-copy" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;">
                            <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
                          </svg>
                          <span>COPY</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Gift Address (conditional) -->
                  <div v-if="client.gift_address" class="elementor-element e-flex e-con-boxed e-con e-child">
                    <div class="e-con-inner" style="display:flex; align-items:center; justify-content:space-between; padding: 12px 0; border-bottom: 1px solid #e0e0e0;">
                      <div style="flex:1;">
                        <p style="margin:0; font-weight:600; font-size:14px; display:flex; align-items:center; gap:6px;">
                          <svg aria-hidden="true" class="e-font-icon-svg e-fas-gift" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;fill:currentColor;"><path d="M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"/></svg>
                          KIRIM KADO
                        </p>
                        <p style="margin:4px 0 0; font-size:13px; color:#555;" v-html="client.gift_address"></p>
                      </div>
                      <div>
                        <a
                          style="cursor: pointer; display:inline-flex; align-items:center; gap:6px; border:1px solid #ccc; border-radius:4px; padding:6px 12px; font-size:12px;"
                          class="elementor-button wdp-copy-btn"
                          role="button"
                          data-message="berhasil disalin"
                          :data-clipboard-text="stripHtml(client.gift_address)"
                        >
                          <svg aria-hidden="true" class="e-font-icon-svg e-far-copy" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" style="width:14px;height:14px;">
                            <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"></path>
                          </svg>
                          <span>COPY</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-4292045 elementor-widget elementor-widget-html"
                  data-id="4292045"
                  data-element_type="widget"
                  data-e-type="widget"
                  data-widget_type="html.default"
                >
                  <div class="elementor-widget-container"></div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-1f7a5bca e-flex e-con-boxed e-con e-child _mPS2id-t"
                data-id="1f7a5bca"
                data-element_type="container"
                data-e-type="container"
                id="galeri"
              >
                <div class="e-con-inner">
                  <div
                    class="elementor-element elementor-element-322221c8 elementor-widget-divider--view-line_icon elementor-widget-divider--element-align-left elementor-view-default elementor-invisible elementor-widget elementor-widget-divider"
                    data-id="322221c8"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"fadeInUp"}'
                    data-widget_type="divider.default"
                  >
                    <div class="elementor-widget-container">
                      <div class="elementor-divider">
                        <span class="elementor-divider-separator">
                          <div class="elementor-icon elementor-divider__element">
                            <svg
                              aria-hidden="true"
                              class="e-font-icon-svg e-fas-quote-left"
                              viewBox="0 0 512 512"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                              ></path>
                            </svg>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="elementor-element elementor-element-1c8cbd8a elementor-invisible elementor-widget elementor-widget-heading"
                    data-id="1c8cbd8a"
                    data-element_type="widget"
                    data-e-type="widget"
                    data-settings='{"_animation":"zoomIn"}'
                    data-widget_type="heading.default"
                  >
                    <div class="elementor-widget-container">
                      <h2 class="elementor-heading-title elementor-size-default">OUR <br />GALLERY</h2>
                    </div>
                  </div>
                  <div v-if="config.gallery_section && gallery.length > 0" class="vue-gallery-section">
                    <div class="vue-gallery-masonry">
                      <div
                        v-for="(item, index) in gallery"
                        :key="item.id || item.file || index"
                        class="vue-gallery-item"
                        role="button"
                        tabindex="0"
                        @click="openLightbox(index)"
                        @keydown.enter.prevent="openLightbox(index)"
                        @keydown.space.prevent="openLightbox(index)"
                      >
                        <img
                          :src="getGalleryImageUrl(item)"
                          :alt="`Wedding photo ${index + 1}`"
                          loading="lazy"
                          class="vue-gallery-img"
                        />
                        <div class="vue-gallery-overlay" aria-hidden="true">
                          <svg viewBox="0 0 24 24">
                            <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                          </svg>
                        </div>
                      </div>
                    </div>

                    <Teleport to="body">
                      <transition name="vue-lightbox-fade">
                        <div v-if="lightboxVisible && gallery.length > 0" class="vue-lightbox" @click.self="closeLightbox">
                          <button type="button" class="vue-lightbox-close" @click="closeLightbox" aria-label="Close gallery">
                            &times;
                          </button>
                          <button
                            type="button"
                            class="vue-lightbox-prev"
                            @click="prevPhoto"
                            :disabled="gallery.length < 2"
                            aria-label="Previous photo"
                          >
                            &#8249;
                          </button>
                          <img
                            v-if="gallery[currentIndex]"
                            :src="getGalleryImageUrl(gallery[currentIndex])"
                            :alt="`Wedding photo ${currentIndex + 1}`"
                            class="vue-lightbox-img"
                          />
                          <button
                            type="button"
                            class="vue-lightbox-next"
                            @click="nextPhoto"
                            :disabled="gallery.length < 2"
                            aria-label="Next photo"
                          >
                            &#8250;
                          </button>
                          <div class="vue-lightbox-counter">{{ currentIndex + 1 }} / {{ gallery.length }}</div>
                        </div>
                      </transition>
                    </Teleport>
                  </div>
                  <div
                    class="elementor-element elementor-element-11390226 e-flex e-con-boxed e-con e-child"
                    data-id="11390226"
                    data-element_type="container"
                    data-e-type="container"
                  >
                    <div class="e-con-inner">
                      <div
                        class="elementor-element elementor-element-587c9aa9 animated-slow elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="587c9aa9"
                        data-element_type="widget"
                        data-e-type="widget"
                        data-settings='{"_animation":"fadeInUp"}'
                        data-widget_type="heading.default"
                      >
                        <div class="elementor-widget-container">
                          <h2 class="elementor-heading-title elementor-size-default">Thank You</h2>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-5c5de4d2 e-con-full e-flex elementor-invisible e-con e-child"
                        data-id="5c5de4d2"
                        data-element_type="container"
                        data-e-type="container"
                        data-settings='{"background_background":"classic","animation":"zoomIn"}'
                        :style="{ backgroundImage: 'url(' + (randomGallerySlots[7] ? getGalleryImageUrl(randomGallerySlots[7]) : '') + ')', backgroundSize: 'cover', backgroundPosition: 'center center' }"
                      >
                        <div
                          class="elementor-element elementor-element-74e079e2 e-con-full e-flex e-con e-child"
                          data-id="74e079e2"
                          data-element_type="container"
                          data-e-type="container"
                        >
                          <div
                            class="elementor-element elementor-element-9073ba2 elementor-widget elementor-widget-spacer"
                            data-id="9073ba2"
                            data-element_type="widget"
                            data-e-type="widget"
                            data-widget_type="spacer.default"
                          >
                            <div class="elementor-widget-container">
                              <div class="elementor-spacer">
                                <div class="elementor-spacer-inner"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-c342c65 animated-slow elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="c342c65"
                        data-element_type="widget"
                        data-e-type="widget"
                        data-settings='{"_animation":"fadeInUp"}'
                        data-widget_type="heading.default"
                      >
                        <div class="elementor-widget-container">
                          <p class="elementor-heading-title elementor-size-default">
                            Merupakan suatu kebahagiaan dan kehormatan bagi kami apabila Bapak/Ibu/Saudara/i, berkenan
                            hadir dan memberikan do’a restu kepada kami.
                          </p>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-31d0b704 animated-slow elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="31d0b704"
                        data-element_type="widget"
                        data-e-type="widget"
                        data-settings='{"_animation":"fadeInUp"}'
                        data-widget_type="heading.default"
                      >
                        <div class="elementor-widget-container">
                          <p class="elementor-heading-title elementor-size-default">Jumi &amp; Ridho</p>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-25905095 e-flex e-con-boxed e-con e-child"
                        data-id="25905095"
                        data-element_type="container"
                        data-e-type="container"
                      >
                        <div class="e-con-inner">
                          <div
                            class="elementor-element elementor-element-4f52bb25 elementor-widget elementor-widget-text-editor"
                            data-id="4f52bb25"
                            data-element_type="widget"
                            data-e-type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div class="elementor-widget-container">
                              Design with
                              <img
                                draggable="false"
                                role="img"
                                class="emoji"
                                alt="?"
                                src="https://s.w.org/images/core/emoji/17.0.2/svg/2764.svg"
                              />
                              by It's Your Day Digital Invitation
                            </div>
                          </div>
                          <div
                            class="elementor-element elementor-element-4cf68636 elementor-widget elementor-widget-image"
                            data-id="4cf68636"
                            data-element_type="widget"
                            data-e-type="widget"
                            data-widget_type="image.default"
                          >
                            <!-- <div class="elementor-widget-container">
                              <a href="/">
                                <img
                                  data-lazyloaded="1"
                                  src="data:image/gif;base64,R0lGODdhAQABAPAAAMPDwwAAACwAAAAAAQABAAACAkQBADs="
                                  loading="lazy"
                                  decoding="async"
                                  width="500"
                                  height="250"
                                  data-src="/favicon.ico"
                                  class="attachment-large size-large wp-image-9575"
                                  alt=""
                                  data-srcset="/favicon.ico 32w"
                                  data-sizes="(max-width: 500px) 100vw, 500px"
                                /><noscript
                                  ><img
                                    loading="lazy"
                                    decoding="async"
                                    width="500"
                                    height="250"
                                    src="assets/wp-content/uploads/2023/08/Digiveet.png"
                                    class="attachment-large size-large wp-image-9575"
                                    alt=""
                                    srcset="
                                      /favicon.ico 32w
                                    "
                                    sizes="(max-width: 500px) 100vw, 500px"
                                /></noscript>
                              </a>
                            </div> -->
                          </div>
                          <div
                            class="elementor-element elementor-element-1deb24b4 elementor-widget elementor-widget-html"
                            data-id="1deb24b4"
                            data-element_type="widget"
                            data-e-type="widget"
                            data-widget_type="html.default"
                          >
                            <div class="elementor-widget-container"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="elementor-element elementor-element-6f410987 notranslate e-flex e-con-boxed e-con e-parent"
      data-id="6f410987"
      data-element_type="container"
      data-e-type="container"
    >
      <div class="e-con-inner">
        <div
          class="elementor-element elementor-element-3edeed63 wdp-sticky-section-positon--default elementor-widget elementor-widget-weddingpress-wellcome"
          data-id="3edeed63"
          data-element_type="widget"
          data-e-type="widget"
          data-widget_type="weddingpress-wellcome.default"
        >
          <div class="elementor-widget-container">
            <div
              class="modalx"
              :style="{ 
                  backgroundColor: '#1b1b1b',
                  backgroundImage: (coverLoaded && client.foto_cover) ? getCoverBackgroundCss(client.foto_cover) : 'none',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundSize: 'cover',
                  WebkitBackgroundSize: 'cover'
              }"
              :class="{ 'cover-loading': !coverLoaded }"
            >
              <div class="overlayy" :style="{ opacity: 1, backgroundColor: coverLoaded ? 'rgba(0,0,0,0.45)' : '#1b1b1b' }"></div>
              <div class="content-modalx">
                <div class="info_modalx">
                  <div class="elementor-image img"></div>

                  <div class="wdp-txt-the-wedding" style="width: auto !important">The Wedding of</div>

                  <div class="wdp-mempelai" style="width: auto !important">{{ pasangan }}</div>

                  <div class="wdp-dear" style="width: auto !important">{{ config.language === 1 ? 'To:' : 'Kpd Bpk/Ibu/Saudara/i' }}</div>

                  <div class="wdp-name namatamu" style="width: auto !important">{{namaTamu}}</div>

                  <div class="wdp-button-wrapper" id="wdp-button-wrapper">
                    <button class="elementor-button">
                      <span class="elementor-button-icon">
                        <svg
                          aria-hidden="true"
                          class="e-font-icon-svg e-far-envelope-open"
                          viewBox="0 0 512 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
                          ></path>
                        </svg>
                      </span>
                      {{ config.language === 1 ? 'Open Invitation' : 'Buka Undangan' }}
                    </button>
                  </div>

                  <div class="wdp-keterangan">{{ config.language === 1 ? 'We apologize for any errors in writing the name/title' : 'Mohon maaf apabila ada kesalahan penulisan nama/gelar' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="elementor-element elementor-element-5e924ca6 wdp-sticky-section-positon--bottom notranslate e-flex e-con-boxed e-con e-parent e-lazyloaded"
      data-id="5e924ca6"
      data-element_type="container"
      data-e-type="container"
    >
      <div class="e-con-inner">
        <div
          class="elementor-element elementor-element-3f035c3c e-con-full e-flex e-con e-child"
          data-id="3f035c3c"
          data-element_type="container"
          data-e-type="container"
        >
          <div
            class="elementor-element elementor-element-91e4de0 elementor-widget elementor-widget-tp-circle-menu"
            data-id="91e4de0"
            data-element_type="widget"
            data-e-type="widget"
            data-widget_type="tp-circle-menu.default"
          >
            <div class="elementor-widget-container">
              <div
                class="plus-circle-menu-wrapper circle_menu6a12f5f1beaa8 layout-circle"
                data-uid="circle_menu6a12f5f1beaa8"
              >
                <div class="plus-circle-menu-inner-wrapper">
                  <ul
                    class="plus-circle-menu circleMenu-closed circle_menu_position_abs"
                    style="list-style: none; margin: 0px; padding: 0px; width: 0px"
                  >
                    <li
                      class="plus-circle-main-menu-list plus-circle-menu-list style-1"
                      style="
                        display: block;
                        width: 0px;
                        height: 0px;
                        text-align: center;
                        line-height: 0px;
                        position: absolute;
                        z-index: 1000;
                        border-radius: 0px;
                        transition: 500ms;
                      "
                    >
                      <a href="#" class="main_menu_icon" style="cursor: pointer"
                        ><svg
                          aria-hidden="true"
                          class="e-font-icon-svg e-fas-home"
                          viewBox="0 0 576 512"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                          ></path></svg></a>
                    </li>
                    <li
                      class="plus-circle-menu-list elementor-repeater-item-c001229 arrow-left"
                      style="
                        display: block;
                        width: 0px;
                        height: 0px;
                        text-align: center;
                        line-height: 0px;
                        position: absolute;
                        z-index: 1;
                        top: 0px;
                        left: 0px;
                        border-radius: 0px;
                        transform: scale(0.5);
                        transition: 500ms;
                      "
                    >
                      <a href="#mempelai" class="menu_icon __mPS2id _mPS2id-h"
                        ><span
                          ><svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-far-heart"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
                            ></path></svg></span
                      ></a>
                    </li>
                    <li
                      class="plus-circle-menu-list elementor-repeater-item-a91b6bd arrow-left"
                      style="
                        display: block;
                        width: 0px;
                        height: 0px;
                        text-align: center;
                        line-height: 0px;
                        position: absolute;
                        z-index: 1;
                        top: 0px;
                        left: 0px;
                        border-radius: 0px;
                        transform: scale(0.5);
                        transition: 500ms;
                      "
                    >
                      <a href="#event" class="menu_icon __mPS2id _mPS2id-h"
                        ><span
                          ><svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-far-calendar-alt"
                            viewBox="0 0 448 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                            ></path></svg></span
                      ></a>
                    </li>
                    <li
                      class="plus-circle-menu-list elementor-repeater-item-a824cf8 arrow-left"
                      style="
                        display: block;
                        width: 0px;
                        height: 0px;
                        text-align: center;
                        line-height: 0px;
                        position: absolute;
                        z-index: 1;
                        top: 0px;
                        left: 0px;
                        border-radius: 0px;
                        transform: scale(0.5);
                        transition: 500ms;
                      "
                    >
                      <a href="#wishes" class="menu_icon __mPS2id"
                        ><span
                          ><svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-far-comment-dots"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                            ></path></svg></span
                      ></a>
                    </li>
                    <li
                      class="plus-circle-menu-list elementor-repeater-item-50bc24a arrow-left"
                      style="
                        display: block;
                        width: 0px;
                        height: 0px;
                        text-align: center;
                        line-height: 0px;
                        position: absolute;
                        z-index: 1;
                        top: 0px;
                        left: 0px;
                        border-radius: 0px;
                        transform: scale(0.5);
                        transition: 500ms;
                      "
                    >
                      <a href="#kado" class="menu_icon __mPS2id _mPS2id-h"
                        ><span
                          ><svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-fas-gift"
                            viewBox="0 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                            ></path></svg></span
                      ></a>
                    </li>
                    <li
                      class="plus-circle-menu-list elementor-repeater-item-f1f0820 arrow-left"
                      style="
                        display: block;
                        width: 0px;
                        height: 0px;
                        text-align: center;
                        line-height: 0px;
                        position: absolute;
                        z-index: 1;
                        top: 0px;
                        left: 0px;
                        border-radius: 0px;
                        transform: scale(0.5);
                        transition: 500ms;
                      "
                    >
                      <a href="#galeri" class="menu_icon __mPS2id _mPS2id-h"
                        ><span
                          ><svg
                            aria-hidden="true"
                            class="e-font-icon-svg e-far-images"
                            viewBox="0 0 576 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
                            ></path></svg></span
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="elementor-element elementor-element-2a41fbbc e-con-full e-flex e-con e-child"
          data-id="2a41fbbc"
          data-element_type="container"
          data-e-type="container"
        >
          <div
            class="elementor-element elementor-element-38ec0bed elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-weddingpress-audio"
            data-id="38ec0bed"
            data-element_type="widget"
            data-e-type="widget"
            data-settings='{"loop":"yes"}'
            data-widget_type="weddingpress-audio.default"
          >
            <div class="elementor-widget-container">
              <div id="audio-container" class="audio-box">
                <audio id="song" loop="">
                  <source src="assets/wp-content/uploads/2024/06/Nadin-Amizah-Kekal-Official-Lyric-Video.mp3" />
                </audio>

                <div class="elementor-icon-wrapper" id="unmute-sound" style="">
                  <div class="elementor-icon elementor-animation-shrink">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-fas-music"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
                      ></path>
                    </svg>
                  </div>
                </div>

                <div class="elementor-icon-wrapper" id="mute-sound" style="display: none">
                  <div class="elementor-icon elementor-animation-shrink">
                    <svg
                      aria-hidden="true"
                      class="e-font-icon-svg e-fas-pause"
                      viewBox="0 0 448 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onServerPrefetch, onMounted, getCurrentInstance, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useHead } from '@unhead/vue';

// Mulai dengan nilai null sehingga komponen tahu data belum ada.
const clientForServer = ref(null);

// Dapatkan akses ke route dan router.
const route = useRoute();
const router = useRouter();

// Dapatkan instance global (misalnya untuk menggunakan $api yang sudah disuntikkan).
const { proxy } = getCurrentInstance();

/*
  Gunakan useHead dengan computed properties untuk mengatur meta tags.
  Nilai default kosong sampai data API didapat.
*/
// === URL gambar OG utama: langsung dari server admin (dinamis per slug) ===
  const ogImageUrl = computed(() => {
    return clientForServer.value && clientForServer.value.foto_cover
      ? `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`
      : `https://itsyourdayofficial.com/og/default-1200x630.jpg`;
  });

  // === URL fallback untuk parser tertentu dengan rasio 1200x630 ===
  const ogImageFallbackUrl = computed(() => {
    if (!clientForServer.value || !clientForServer.value.foto_cover) {
      return `https://itsyourdayofficial.com/og/default-1200x630.jpg`;
    }
    const original = `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`;
    return `https://images.weserv.nl/?url=${encodeURIComponent(original.replace(/^https?:\/\//, ''))}&w=1200&h=630&fit=cover&a=center&output=jpg&q=85`;
  });

  // === Dynamic page URL ===
  const pageUrl = computed(() => {
    const origin = typeof window !== 'undefined'
      ? window.location.origin
      : 'https://temurindu.itsyourdayofficial.com';
    return `${origin}/${route.params.slug || ''}`;
  });

  // === Ordered couple names respecting hajat field ===
  const orderedCoupleNames = computed(() => {
    if (!clientForServer.value || !clientForServer.value.nama_wanita || !clientForServer.value.nama_pria) {
      return "";
    }
    return clientForServer.value.hajat === 'wanita'
      ? `${clientForServer.value.nama_wanita} & ${clientForServer.value.nama_pria}`
      : `${clientForServer.value.nama_pria} & ${clientForServer.value.nama_wanita}`;
  });


  const faviconHref = computed(() => {
    if (clientForServer.value && clientForServer.value.foto_cover) {
      return `https://admin.itsyourdayofficial.com/foto_cover/${clientForServer.value.foto_cover}`;
    }
    return '/favicon.ico';
  });

  const syncFaviconLinks = (href) => {
    if (typeof document === 'undefined' || !href) return;

    const ensureLink = (rel) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    ensureLink('icon');
    ensureLink('shortcut icon');
    ensureLink('apple-touch-icon');
  };

  // === Complete Meta OG with Twitter Cards (1200x630 untuk WhatsApp & Web Crawlers) ===
  useHead({
    title: computed(() => {
      return orderedCoupleNames.value ? `Wedding Invitation ${orderedCoupleNames.value}` : "";
    }),
    meta: [
      { key: "description", name: "description", content: computed(() =>
        orderedCoupleNames.value
          ? `Mohon doa dan restunya atas pernikahan kami ${orderedCoupleNames.value}`
          : ""
      )},
      { key: "og:title", property: "og:title", content: computed(() =>
        orderedCoupleNames.value ? `Wedding of ${orderedCoupleNames.value}` : ""
      )},
      { key: "og:description", property: "og:description", content: computed(() =>
        orderedCoupleNames.value
          ? `Mohon doa dan restunya atas pernikahan kami ${orderedCoupleNames.value}`
          : ""
      )},
      { key: "og:url", property: "og:url", content: pageUrl },
      { key: "og:type", property: "og:type", content: "website" },
      
      // === Twitter Card (untuk compatibility lintas platform) ===
      { key: "twitter:card", name: "twitter:card", content: "summary_large_image" },
      { key: "twitter:title", name: "twitter:title", content: computed(() =>
        orderedCoupleNames.value ? `Wedding of ${orderedCoupleNames.value}` : ""
      )},
      { key: "twitter:description", name: "twitter:description", content: computed(() =>
        orderedCoupleNames.value ? `Mohon doa dan restunya atas pernikahan kami ${orderedCoupleNames.value}` : ""
      )},

      // === OG Image (primary + variants untuk WhatsApp Web & Facebook) ===
      { key: "og:image", property: "og:image", content: ogImageUrl },
      { key: "og:image:url", property: "og:image:url", content: ogImageUrl },
      { key: "og:image:secure_url", property: "og:image:secure_url", content: ogImageUrl },
      { key: "twitter:image", name: "twitter:image", content: ogImageUrl },
      { key: "og:image:width",  property: "og:image:width",  content: "1200" },
      { key: "og:image:height", property: "og:image:height", content: "630" },
      { key: "og:image:type",   property: "og:image:type",   content: "image/jpeg" },
    ],
    link: [
      {
        key: 'favicon',
        rel: "icon",
        href: faviconHref,
      },
      {
        key: 'favicon-shortcut',
        rel: 'shortcut icon',
        href: faviconHref,
      },
      {
        key: 'favicon-apple',
        rel: 'apple-touch-icon',
        href: faviconHref,
      },
    ],
  });

watch(faviconHref, (href) => {
  syncFaviconLinks(href);
}, { immediate: true });

/*
  Fungsi fetchclientData() melakukan API call untuk mengambil data berdasarkan route.
  Kami menangani parameter 'to' dengan cara:
  1. Mengambil nilai dari route (tersedia baik pada SSR maupun client-side).
  2. Decode parameter tersebut.
  3. Validasi menggunakan regex: format yang valid adalah hanya alfanumerik dengan tanda strip sebagai pemisah (misalnya, "Juju-Dan-Suami").
     Jika tidak memenuhi (misalnya hanya satu kata atau mengandung spasi/karakter lain), maka parameter dikosongkan.
  4. Menentukan URL template berdasarkan lingkungan (SSR atau client).
*/
async function fetchclientData() {
  let toParam = route.query.to || "";  
//   console.log("Param to:", toParam);
  if (toParam) {
    const decodedTo = decodeURIComponent(toParam);
    // Regex valid: minimal dua kata (alfanumerik) yang dipisahkan oleh strip, tanpa spasi atau karakter khusus lain.
    const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
    if (!validDBPattern.test(decodedTo)) {
      // Bila tidak sesuai, parameter dikosongkan untuk API request.
      toParam = "";
    } else {
      // Jika valid, gunakan nilai decoded.
      toParam = decodedTo;
    }
  }

  // Jika window tidak tersedia (SSR), gunakan URL fallback.
  const templateUrl =
    typeof window !== "undefined"
      ? window.location.origin + "/"
      : "	https://temurindu.itsyourdayofficial.com/"; //host
    // : "http://localhost:8080/";  //local

  try {
    // console.log("Memulai fetch API dengan slug: ", route.params.slug);
    // console.log("Template URL:", templateUrl);
    const response = await proxy.$api.get('/' + route.params.slug, {
      params: {
        to: toParam,
        template: templateUrl,
      },
    });
    if (response.data.data) {
      clientForServer.value = response.data.data;
    } else {
      router.push({ name: 'NotFoundPage' });
    }
  } catch (error) {
    console.error("Error fetching clientForServer data:", error);
  }
}

/*
  onServerPrefetch() hanya dipanggil saat SSR.
  Server akan menunggu Promise yang dikembalikan sehingga data sudah tersedia sebelum render.
*/
onServerPrefetch(async () => {
  await fetchclientData();
});

/*
  onMounted() adalah fallback untuk rendering client-side.
  Jika data belum ada (misalnya karena navigasi client-side), API dipanggil ulang.
*/
onMounted(async () => {
  if (!clientForServer.value) {
    await fetchclientData();
  }
});
</script>

<script>
  import moment from "moment";
  // import VueHorizontal from "vue-horizontal";
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }
  export default {
    components: {
      // Modal,
    },
    data() {
      return {
        client: {},
        accObserver: null,
        fallbackName: "",
        guest: {},
        moment: moment,
        date: "",
        config: {},
        now: 0,
        count: 0,
        gallery: [],
        randomGallerySlots: [],
        currentSlideIndex: 0,
        slideshowInterval: null,
        currentIndex: 0,
        coverLoaded: false,
        lightboxVisible: false,
        Lightbox: null,
        hasPrev: false,
        hasNext: true,
        autoScrollInterval: null, // untuk menyimpan ID interval auto-scroll
        showGallery: false,
        interval: null,
        name: "",
        picked: "",
        jumlah: "",
        isSubmittingWA: false,
        story: {
          title1: "",
          description1: "",
          date1: "",
          month1: "",
          year1: "",
          media1: "",
          type1: "",
          order1: "",
          rangeTime1: "",
          title2: "",
          description2: "",
          date2: "",
          month2: "",
          year2: "",
          media2: "",
          type2: "",
          order2: "",
          rangeTime2: "",
          title3: "",
          description3: "",
          date3: "",
          month3: "",
          year3: "",
          media3: "",
          type3: "",
          order3: "",
          rangeTime3: "",
          title4: "",
          description4: "",
          date4: "",
          month4: "",
          year4: "",
          media4: "",
          type4: "",
          order4: "",
          rangeTime4: "",
          title5: "",
          description5: "",
          date5: "",
          month5: "",
          year5: "",
          media5: "",
          type5: "",
          order5: "",
          rangeTime5: "",
        },
        hopes: [],
        submit: {
            client_id: '',
            name: '',
            comment: '',
            confirmation: '',
        },
        snackbar: false,
        messageSnackBar: 'Ucapan anda sudah terkirim, terima kasih.',
        errors: {},
        isSubmittingWish: false,
        isAmplopVisible: false,
      };
    },
    mounted() {
      import("vue-easy-lightbox")
        .then((module) => {
          this.Lightbox = module.default;
        })
        .catch((err) => {
          console.error("Gagal memuat vue-easy-lightbox:", err);
        });

      window.addEventListener("scroll", debounce(this.checkScroll, 100), { passive: true });
      this._onLightboxKeydown = (event) => this.onLightboxKeydown(event);
      window.addEventListener("keydown", this._onLightboxKeydown);

      // Wedding Gift button - register window-level toggle function
      window.__toggleAmplop = () => {
        const amplopEl = document.getElementById('amplop');
        if (amplopEl) {
          if (amplopEl.style.display === 'none' || amplopEl.style.display === '') {
            amplopEl.style.display = 'block';
          } else {
            amplopEl.style.display = 'none';
          }
        }
      };

      let rawToParam = this.getOriginalQueryParam("to") || "";
      if (rawToParam) {
        // decode untuk validasi
        const decodedTo = decodeURIComponent(rawToParam);
        /*  
                Kita gunakan regex untuk menentukan format yang valid.
                Format valid adalah:
                    - Satu atau lebih kata (hanya A-Z atau a-z atau angka) 
                    - Dipisah dengan tanda strip (misalnya: Kata1-Kata2 atau kata1-kata2-kata3)
                Contoh:
                    • "Juju-Dan-Suami" → valid.
                    • "Desty" (hanya 1 kata) → tidak valid.
                    • "Ibu. Desty - Suami" → tidak valid karena mengandung spasi, titik, atau karakter lain.
                    Jika tidak valid, simpan fallbackName dan kosongkan parameter untuk API
                */
        const validDBPattern = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/;
        if (!validDBPattern.test(decodedTo)) {
          // Simpan nilai fallback agar computed property bisa menggunakannya
          this.fallbackName = decodedTo;
          // Jika tidak memenuhi pola, gunakan nilai kosong untuk request API.
          rawToParam = "";
        }
      }

      const isBlank = (v) => v === null || v === undefined || String(v).trim() === "";
      const nv = (v) => (isBlank(v) ? "—" : String(v));
      // Elementor bisa memindahkan node, jadi pakai dokumen penuh
      const getRoot = () => document;

      // Mengubah HTML menjadi teks polos (hapus <p>, <br>, dsb) lalu trim spasi
      const htmlToPlain = (html) => {
        if (html == null) return '';
        // Ganti <br> menjadi baris baru agar tetap terbaca
        const normalized = String(html).replace(/<br\s*\/?>/gi, '\n');
        const tmp = document.createElement('div');
        tmp.innerHTML = normalized;
        const text = tmp.textContent || tmp.innerText || '';
        return text.replace(/\s+\n/g, '\n').replace(/\n{2,}/g, '\n').trim();
      };


      // === UI: penerima & gift address ===
      const updateRecipientAndAddressUI = () => {
        const root = typeof getRoot === 'function' ? getRoot() : document;
        const isEmpty = (v) => (typeof isBlank === 'function' ? isBlank(v) : (v == null || String(v).trim() === ''));

        // --- Tentukan label penerima berdasar query recipient=wanita|pria; default 'wanita' lalu fallback ke pasangannya ---
        const rawPref = (this.getOriginalQueryParam && this.getOriginalQueryParam('recipient')) || '';
        const pref = String(rawPref).toLowerCase().trim() === 'pria' ? 'pria' : 'wanita';

        const namaWanita = this.client?.nama_wanita ?? '';
        const namaPria   = this.client?.nama_pria ?? '';

        let recipientLabel = '';
        if (pref === 'wanita') {
          recipientLabel = !isEmpty(namaWanita) ? namaWanita : (!isEmpty(namaPria) ? namaPria : '');
        } else {
          recipientLabel = !isEmpty(namaPria) ? namaPria : (!isEmpty(namaWanita) ? namaWanita : '');
        }

        // Jika Anda ingin selalu menampilkan KEDUA nama ketika keduanya ada, gunakan baris ini sebagai pengganti:
        recipientLabel = [namaWanita, namaPria].filter((x) => !isEmpty(x)).join(' - ') || '';

        // --- Tulis ke <h2 data-field="penerima"> dengan tampilan lebih eye-catching ---
        const penerimaNodes = root.querySelectorAll('[data-field="penerima"]');
        penerimaNodes.forEach((h2) => {
          if (isEmpty(recipientLabel)) {
            h2.innerHTML = '<span class="ui-label">Penerima:</span>';
          } else {
            h2.innerHTML = `
              <span class="ui-label">Penerima:</span><br/>
              <span class="ui-value">${recipientLabel}<br/></span>
            `;
          }
        });

        // --- Sanitasi gift_address agar TIDAK ada tag <p> & sejenis ---
        const giftAddress = this.client?.gift_address ?? '';
        const cleanAddress = htmlToPlain(giftAddress);

        // --- Tulis alamat & kontrol visibilitas container besar ---
        const alamatNodes = root.querySelectorAll('[data-field="alamat"]');
        alamatNodes.forEach((h2) => {
          if (isEmpty(cleanAddress)) {
            h2.innerHTML = '<span class="ui-label">Alamat:</span>';
          } else {
            h2.innerHTML = `
              <span class="ui-label">Alamat:</span><br/>
              <span class="ui-value">${cleanAddress.replace(/\n/g, '<br/>')}</span>
            `;
          }
        });

        // --- Hide/Show container besar jika gift_address kosong ---
        const containers = root.querySelectorAll('[data-id="5ac031ce"], .elementor-element-5ac031ce');
        const hideAll = isEmpty(cleanAddress);
        containers.forEach((el) => {
          el.style.display = hideAll ? 'none' : '';
        });
        // console.log('[UI] penerima+alamat =>',
        //   `recipient="${recipientLabel || '(kosong)'}", gift_address="${cleanAddress || '(kosong)'}",`,
        //   hideAll ? 'HIDE container 5ac031ce' : 'SHOW container 5ac031ce'
        // );

        // --- Sinkronkan nilai clipboard untuk "Copy Alamat" (tanpa <p>) ---
        const clipInputAddr = root.querySelector('#copy-gift-address');
        if (clipInputAddr) {
          clipInputAddr.value = cleanAddress || '—';
        }

        // --- (Opsional) Hide blok copy jika alamat kosong ---
        const copyAddrBlock = root.querySelector('[data-id="68287e52"], .elementor-element-68287e52');
        if (copyAddrBlock && copyAddrBlock.matches('.alamat-container')) {
            copyAddrBlock.style.display = isEmpty(cleanAddress) ? 'none' : '';
        }



      };

      // Ambil nilai TAMPIL per-set (punya fallback utk set 2-4 seperti script Anda semula)
      const getSetValues = (i) => {
        const bankKey = i === 1 ? "bank" : `bank${i}`;
        const accBankKey = i === 1 ? "acc_bank" : `acc_bank${i}`;
        const noAccKey = i === 1 ? "no_acc" : `no_acc${i}`;

        const bank = this.client[bankKey];
        const acc_bank = accBankKey in this.client ? this.client[accBankKey] : this.client["acc_bank"];
        const no_acc = noAccKey in this.client ? this.client[noAccKey] : this.client["no_acc"];
        return { bank, acc_bank, no_acc };
      };

      // Sembunyikan/ tampilkan wrapper set-i berdasarkan NILAI MENTAH (tanpa fallback)
      const hideBySet = (i) => {
        // Ambil nilai mentah untuk logika hide
        const rawBank = i === 1 ? this.client.bank : this.client[`bank${i}`];
        const rawAcc = i === 1 ? this.client.acc_bank : this.client[`acc_bank${i}`];
        const rawNo = i === 1 ? this.client.no_acc : this.client[`no_acc${i}`];

        const shouldHide = isBlank(rawBank) && isBlank(rawAcc) && isBlank(rawNo);

        const root = getRoot();
        // Kumpulkan elemen-elemen 1 set untuk menemukan wrapper-nya
        const setEls = root.querySelectorAll(
          `[data-field="bank-${i}"],
         [data-field="acc_bank-${i}"],
         [data-field="no_acc-${i}"],
         #dce-clipboard-value-${i},
         [data-field="clipboard_no_acc-${i}"]`
        );

        const wrappers = new Set();
        setEls.forEach((el) => {
          const w = el.closest(".dce-acf-repeater-item");
          if (w) wrappers.add(w);
        });

        wrappers.forEach((w) => {
          w.style.display = shouldHide ? "none" : "";
        });

        // Log sederhana
        // console.log(`[UI] set-${i} visibility =>`, shouldHide ? "hidden" : "shown");
      };

      // Tulis 1 set (i=1..4) & atur visibilitasnya
      const writeSet = (i) => {
        const root = getRoot();
        const { bank, acc_bank, no_acc } = getSetValues(i);

        const elsBank = root.querySelectorAll(`[data-field="bank-${i}"]`);
        const elsAcc = root.querySelectorAll(`[data-field="acc_bank-${i}"]`);
        const elsNo = root.querySelectorAll(`[data-field="no_acc-${i}"]`);
        const elsClip = root.querySelectorAll(`#dce-clipboard-value-${i}, [data-field="clipboard_no_acc-${i}"]`);

        // Debug hitungan elemen supaya tahu selector kena atau tidak
        // console.log(`[DEBUG] set-${i} matches: bank=${elsBank.length}, acc_bank=${elsAcc.length}, no_acc=${elsNo.length}, clip=${elsClip.length}`);

        elsBank.forEach((el) => {
          const v = nv(bank);
          if (el.textContent !== v) {
            el.textContent = v;
            // console.log(`[UI] bank-${i} =>`, v);
          }
        });

        elsAcc.forEach((el) => {
          const v = nv(acc_bank);
          if (el.textContent !== v) {
            el.textContent = v;
            // console.log(`[UI] acc_bank-${i} =>`, v);
          }
        });

        elsNo.forEach((el) => {
          const v = nv(no_acc);
          if (el.textContent !== v) {
            el.textContent = v;
            // console.log(`[UI] no_acc-${i} =>`, v);
          }
        });

        elsClip.forEach((el) => {
          const v = nv(no_acc);
          if (el.value !== undefined) {
            if (el.value !== v) {
              el.value = v;
              // console.log(`[UI] clipboard_no_acc-${i} =>`, v);
            }
          } else if (el.textContent !== v) {
            el.textContent = v;
            // console.log(`[UI] clipboard_no_acc-${i} (text) =>`, v);
          }
        });

        // TERAKHIR: atur visibilitas wrapper set-i
        hideBySet(i);
      };

      // Tulis semua set sekaligus
      const writeAllSets = () => {
        const rows = [];
        for (let i = 1; i <= 4; i++) {
          const v = getSetValues(i);
          rows.push({ set: i, bank: v.bank, acc_bank: v.acc_bank, no_acc: v.no_acc });
          writeSet(i); // ini juga otomatis hide/show per set
        }
        // console.table(rows);
      };

      // Delegasi copy (tetap)
      const onClickCopyDelegate = async (e) => {
        const btn = e.target.closest('[data-clipboard-target^="#dce-clipboard-value-"], [data-clipboard-target="#copy-gift-address"]');
        if (!btn) return;

        const targetSelector = btn.getAttribute("data-clipboard-target");
        const target = document.querySelector(targetSelector);
        if (!target) {
          // console.log("[DEBUG] copy: target tidak ditemukan =>", targetSelector);
          return;
        }

        // Pastikan target per-set diisi terbaru
        const m = targetSelector.match(/dce-clipboard-value-(\d+)/);
        if (m) writeSet(Number(m[1]));
        else writeAllSets();

        const text = target.value ?? target.textContent ?? "";
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
          } else {
            if (target.select) {
              target.select();
              target.setSelectionRange(0, text.length);
              document.execCommand("copy");
            } else {
              const temp = document.createElement("input");
              temp.style.position = "absolute";
              temp.style.left = "-9999px";
              temp.value = text;
              document.body.appendChild(temp);
              temp.select();
              document.execCommand("copy");
              document.body.removeChild(temp);
            }
          }
          const label = btn.querySelector(".elementor-button-text");
          const old = label ? label.textContent : "Copy Rekening";
          if (label) label.textContent = "Copied";
          btn.disabled = true;
          setTimeout(() => {
            if (label) label.textContent = old;
            btn.disabled = false;
          }, 1500);
          // console.log("[DEBUG] copied =>", text);
        } catch (err) {
          // console.warn("[DEBUG] copy gagal:", err);
        }
      };

      document.addEventListener("click", onClickCopyDelegate);
      this._unbindCopyDelegate = () => document.removeEventListener("click", onClickCopyDelegate);

      // ==== Observer DOM (aktif setelah data siap) ====
      let rafPending = false;
      this.accObserver = new MutationObserver(() => {
        if (!this._dataReady) return;
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(() => {
          rafPending = false;
          writeAllSets();
          updateRecipientAndAddressUI();
        });
      });
      this.accObserver.observe(document.body, { childList: true, subtree: true });

      // ---- Ambil data kamu seperti biasa ----
      const template = window.location.origin + "/";
      const slug = this.$route.params.slug;

      // console.group("[API] Fetch client");
      // console.info("GET", `/${slug}`, { to: this.getOriginalQueryParam("to") || "", template });
      // const t0 = performance.now();

      // Lakukan request API dengan parameter yang telah divalidasi (jika valid, rawToParam berisi string valid,
      // jika tidak valid, rawToParam akan kosong dan fallbackName akan terisi)
      this.$api
        .get("/" + slug, { params: { to: rawToParam, template } })
        .then(async (response) => {
          // const t1 = performance.now();
          // console.info("✓ Response status:", response.status, response.statusText);
          // Pastikan payload ada
          const data = response && response.data && response.data.data;

          if (!data) {
            // console.error("✗ data.data TIDAK ADA. Payload penuh:", response.data);
            // console.groupEnd();
            this.$router.push({ name: "NotFoundPage" });
            return;
          }

          // 1) Assign dulu
          Object.assign(this.client, data);

          // 2) Tandai data siap (observer boleh menulis)
          this._dataReady = true;

          // 3) Log state dan CETAK satu tabel
          // console.info("State client terisi:", {
          //   bank: this.client.bank,
          //   bank2: this.client.bank2,
          //   bank3: this.client.bank3,
          //   bank4: this.client.bank4,
          //   acc_bank: this.client.acc_bank,
          //   acc_bank2: this.client.acc_bank2,
          //   acc_bank3: this.client.acc_bank3,
          //   acc_bank4: this.client.acc_bank4,
          //   no_acc: this.client.no_acc,
          //   no_acc2: this.client.no_acc2,
          //   no_acc3: this.client.no_acc3,
          //   no_acc4: this.client.no_acc4,
          // });

          const rows = [];
          for (let i = 1; i <= 4; i++) {
            const v = {
              bank: i === 1 ? this.client.bank : this.client[`bank${i}`],
              acc_bank: i === 1 ? this.client.acc_bank : this.client[`acc_bank${i}`] ?? this.client.acc_bank,
              no_acc: i === 1 ? this.client.no_acc : this.client[`no_acc${i}`] ?? this.client.no_acc,
            };
            rows.push({ set: i, ...v });
          }
          // console.table(rows);
          // console.debug("Durasi:", (t1 - t0).toFixed(1), "ms");

          // 4) Tulis UI sekarang
          writeAllSets();
          updateRecipientAndAddressUI();

          var currentUrl = window.location.href;
          this.guest = response.data.data;
          if (currentUrl.includes(this.client.template) == false) {
            this.$router.push({ name: "NotFoundPage" });
          }
          const unduhMantuDate = response.data.data.tgl_unduh_mantu;
          const isValidUnduhMantu = unduhMantuDate && moment(unduhMantuDate).year() > 2000;
          if (response.data.data.config[0].countdown == 1) {
            this.date = moment(response.data.data.tgl_resepsi).format("YYYY-MM-DDTHH:mm:ss");
          } else if (isValidUnduhMantu) {
            this.date = moment(unduhMantuDate).format("YYYY-MM-DDTHH:mm:ss");
          } else {
            this.date = moment(response.data.data.tgl_akad).format("YYYY-MM-DDTHH:mm:ss");
          }
          this.config = response.data.data.config[0];
          this.timer_loop();
          this.$nextTick(() => this.initScrollAnimations());
          this.modifiedDate = Math.trunc(Date.parse(this.date) / 1000);

          // Prioritaskan cover agar dimuat dulu sebelum burst request gallery.
          // Timeout ditingkatkan ke 3 detik untuk Safari iPhone dengan network lebih lambat
          // Fallback: set coverLoaded = true setelah timeout untuk prevent blank image
          const coverUrl = this.getCoverImageUrl(this.client.foto_cover);
          if (coverUrl) {
            await Promise.race([
              this.preloadCoverImage(coverUrl),
              new Promise((resolve) => setTimeout(resolve, 3000)),
            ]);
            // Always set to true after race completes (either image loaded atau timeout)
            this.coverLoaded = true;
          } else {
            this.coverLoaded = false;
          }

          this.gallery = response.data.data.gallery;
          this.pickRandomGallerySlots();
          this.pages = this.gallery.length;
          // Update hasNext property based on whether gallery has items
          this.hasNext = this.gallery.length > 1;
          this.startSlideshow();
          this.story.title1 = response.data.data.story[0];
          this.story.description1 = response.data.data.story[0];
          this.story.date1 = response.data.data.story[0];
          this.story.month1 = response.data.data.story[0];
          this.story.year1 = response.data.data.story[0];
          this.story.media1 = response.data.data.story[0];
          this.story.type1 = response.data.data.story[0];
          this.story.order1 = response.data.data.story[0];
          this.story.rangeTime1 = response.data.data.story[0];
          this.story.title2 = response.data.data.story[1];
          this.story.description2 = response.data.data.story[1];
          this.story.date2 = response.data.data.story[1];
          this.story.month2 = response.data.data.story[1];
          this.story.year2 = response.data.data.story[1];
          this.story.media2 = response.data.data.story[1];
          this.story.type2 = response.data.data.story[1];
          this.story.order2 = response.data.data.story[1];
          this.story.rangeTime2 = response.data.data.story[1];
          this.story.title3 = response.data.data.story[2];
          this.story.description3 = response.data.data.story[2];
          this.story.date3 = response.data.data.story[2];
          this.story.month3 = response.data.data.story[2];
          this.story.year3 = response.data.data.story[2];
          this.story.media3 = response.data.data.story[2];
          this.story.type3 = response.data.data.story[2];
          this.story.order3 = response.data.data.story[2];
          this.story.rangeTime3 = response.data.data.story[2];
          this.story.title4 = response.data.data.story[3];
          this.story.description4 = response.data.data.story[3];
          this.story.date4 = response.data.data.story[3];
          this.story.month4 = response.data.data.story[3];
          this.story.year4 = response.data.data.story[3];
          this.story.media4 = response.data.data.story[3];
          this.story.type4 = response.data.data.story[3];
          this.story.order4 = response.data.data.story[3];
          this.story.rangeTime4 = response.data.data.story[3];
          this.story.title5 = response.data.data.story[4];
          this.story.description5 = response.data.data.story[4];
          this.story.date5 = response.data.data.story[4];
          this.story.month5 = response.data.data.story[4];
          this.story.year5 = response.data.data.story[4];
          this.story.media5 = response.data.data.story[4];
          this.story.type5 = response.data.data.story[4];
          this.story.order5 = response.data.data.story[4];
          this.story.rangeTime5 = response.data.data.story[4];
          this.submit.client_id = this.client.id;
          this.picked = this.config.language === 1 ? "Yes, I would love to attend" : "Iya, Saya akan Hadir";
          if (this.$refs.horizontal) {
            this.$refs.horizontal.scrollToIndex(1);
          }
          // Mulai auto-scroll jika gallery terlihat
          if (this.showGallery) {
            this.startAutoScroll();
          }
          this.startAutoScrollStoryImage();
          this.$api.get('comment/' + this.client.id)
            .then(response => {
                const raw = response.data.data;
                this.hopes = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []);
            })
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            console.log(error.response.data);
          } else {
            console.error(error);
          }
        });
    },

    computed: {
      hopesCount() {
        return Array.isArray(this.hopes) ? this.hopes.length : 0;
      },
      backgroundStyle() {
        if (this.client.foto_cover) {
          return {
            backgroundImage: `url('https://admin.itsyourdayofficial.com/foto_cover/${this.client.foto_cover}')`,
            backgroundPosition: "center center",
            backgroundSize: "cover",
          };
        }
        return {};
      },

      pasangan() {
        // Pastikan data client sudah lengkap sebelum mengembalikan string
        if (this.client && this.client.nama_pria && this.client.nama_wanita && this.client.hajat) {
          if (this.client.hajat === "wanita") {
            return `${this.client.nama_wanita} & ${this.client.nama_pria}`;
          } else {
            return `${this.client.nama_pria} & ${this.client.nama_wanita}`;
          }
        }
        // Jika data belum lengkap, kembalikan string kosong
        return "";
      },

      namaPertama() {
        return this.client.hajat === "wanita" ? this.client.nama_wanita : this.client.nama_pria;
      },
      namaKedua() {
        return this.client.hajat === "wanita" ? this.client.nama_pria : this.client.nama_wanita;
      },

      namaTamu() {
        // Jika guest.nama tersedia, gunakan itu
        if (this.guest && this.guest.nama) {
          return this.guest.nama;
        }
        // Jika tidak, gunakan fallbackName
        return this.fallbackName || "";
      },

      seconds() {
        const result = (this.modifiedDate - this.now) % 60;
        return result < 0 ? 0 : result;
      },
      minutes() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60) % 60;
        return result < 0 ? 0 : result;
      },
      hours() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60) % 24;
        return result < 0 ? 0 : result;
      },
      days() {
        const result = Math.trunc((this.modifiedDate - this.now) / 60 / 60 / 24);
        return result < 0 ? 0 : result;
      },
      modifiedDate: function () {
        if (!this.date) return 0;
        return moment(this.date).unix();
      },

      currentBackgroundStyle() {
        if (this.gallery.length === 0) return {};
        return {
          backgroundImage: `url('${this.getGalleryImageUrl(this.gallery[this.currentSlideIndex])}')`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          transition: "background-image 1s ease-in-out",
        };
      },
      imageList() {
        return this.gallery.map((item) => this.getGalleryImageUrl(item));
      },

      formattedHashtag() {
        const capitalize = (str) => {
          if (!str) return "";
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        const firstName = this.client.hajat === "wanita" ? this.client.nama_wanita : this.client.nama_pria;
        const secondName = this.client.hajat === "wanita" ? this.client.nama_pria : this.client.nama_wanita;

        return `#${capitalize(firstName)}${capitalize(secondName)}`;
      },
      confirmationText() {
        if (this.config.language === 1) {
          return "Help us prepare the event better by filling out the <b>Attendance Confirmation</b> form below:";
        } else {
          return "Bantu kami mempersiapkan acara lebih baik dengan mengisi form <b>Konfirmasi Kehadiran</b> berikut:";
        }
      },
    },
    beforeUnmount() {
      // Clean up all intervals and timeouts
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
      }
      if (this.interval) {
        clearInterval(this.interval);
      }
      if (this._countdownInterval) {
        clearInterval(this._countdownInterval);
        this._countdownInterval = null;
      }

      if (this.accObserver) {
        this.accObserver.disconnect();
        this.accObserver = null;
      }
      if (this._scrollObserver) {
        this._scrollObserver.disconnect();
        this._scrollObserver = null;
      }

      if (typeof document !== "undefined" && document.body) {
        document.body.style.overflow = "";
      }

      window.removeEventListener("scroll", this.checkScroll);
      window.removeEventListener("keydown", this._onLightboxKeydown);
    },
    methods: {
      initScrollAnimations() {
        if (typeof IntersectionObserver === 'undefined') return;
        if (this._scrollObserver) {
          this._scrollObserver.disconnect();
        }
        this._scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('sa-visible');
              this._scrollObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        document.querySelectorAll('[data-sa]').forEach(el => {
          // Skip elements already visible
          if (!el.classList.contains('sa-visible')) {
            this._scrollObserver.observe(el);
          }
        });
      },
      getOriginalQueryParam(paramName) {
        // Pastikan hanya mencoba mengakses window jika ada
        if (typeof window === "undefined") return null;
        const queryString = window.location.search;
        const regex = new RegExp(`[?&]${paramName}=([^&]+)`);
        const matches = regex.exec(queryString);
        return matches && matches.length > 1 ? matches[1] : null;
      },
      getBankLogo(bankName) {
        if (!bankName) return null;
        const map = {
          'BCA':     '/assets/bca.png',
          'BRI':     '/assets/bri.png',
          'BSI':     '/assets/bsi.png',
          'MANDIRI': '/assets/mandiri.png',
          'BNI':     '/assets/bni.png',
          // Tambahkan bank lain di sini jika diperlukan
        };
        const key = bankName.toUpperCase().trim();
        return map[key] || null;
      },
      stripHtml(html) {
        if (!html) return '';
        if (typeof document === 'undefined') {
          // SSR fallback: strip tags with regex
          return html.replace(/<[^>]*>/g, '').trim();
        }
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return (tmp.textContent || tmp.innerText || '').trim();
      },
      timer_loop() {
        // Bersihkan interval lama jika ada
        if (this._countdownInterval) {
          clearInterval(this._countdownInterval);
        }
        // Perbarui 'now' langsung dan setiap detik
        this.now = Math.trunc(new Date().getTime() / 1000);
        this._countdownInterval = setInterval(() => {
          this.now = Math.trunc(new Date().getTime() / 1000);
        }, 1000);
      },

      pickRandomGallerySlots() {
        if (!this.gallery || this.gallery.length === 0) {
          this.randomGallerySlots = [];
          return;
        }
        // Fisher-Yates shuffle a copy, then pick first 9 items (or fewer if gallery is small)
        const shuffled = [...this.gallery].sort(() => Math.random() - 0.5);
        this.randomGallerySlots = shuffled.slice(0, 9);
      },

      startSlideshow() {
        if (this.gallery.length < 2) return;
        this.slideshowInterval = setInterval(() => {
          this.currentSlideIndex = (this.currentSlideIndex + 1) % this.gallery.length;
        }, 3000); // Ganti setiap 2 detik
      },

      getGalleryBaseUrl() {
        const apiBase = (this.$api && this.$api.defaults && this.$api.defaults.baseURL) || "https://admin.itsyourdayofficial.com/api/";
        return apiBase.replace(/\/api\/?$/, "/gallery/");
      },

      getClientPhotoUrl(filename) {
        if (!filename) return "";
        const apiBase = (this.$api && this.$api.defaults && this.$api.defaults.baseURL) || "https://admin.itsyourdayofficial.com/api/";
        const baseUrl = apiBase.replace(/\/api\/?$/, "/foto_calon/");
        return `${baseUrl}${filename}`;
      },

      getBridePhotoUrl() {
        const filename = this.client && this.client.hajat === 'wanita'
          ? this.client.foto_wanita
          : (this.client ? this.client.foto_pria : '');
        return this.getClientPhotoUrl(filename);
      },

      getGroomPhotoUrl() {
        const filename = this.client && this.client.hajat === 'wanita'
          ? this.client.foto_pria
          : (this.client ? this.client.foto_wanita : '');
        return this.getClientPhotoUrl(filename);
      },

      getGalleryImageUrl(item) {
        if (!item || !item.file) return "";
        return `${this.getGalleryBaseUrl()}${item.file}`;
      },

      getCoverBaseUrl() {
        const apiBase = (this.$api && this.$api.defaults && this.$api.defaults.baseURL) || "https://admin.itsyourdayofficial.com/api/";
        return apiBase.replace(/\/api\/?$/, "/foto_cover/");
      },

      getCoverImageUrl(filename) {
        if (!filename) return "";
        if (filename.startsWith("http://") || filename.startsWith("https://")) {
          return encodeURI(filename);
        }
        return encodeURI(`${this.getCoverBaseUrl()}${filename}`);
      },

      getCoverBackgroundCss(filename) {
        const url = this.getCoverImageUrl(filename);
        if (!url) return "none";
        const safeUrl = url.replace(/"/g, "%22");
        return `url("${safeUrl}")`;
      },

      preloadCoverImage(url) {
        return new Promise((resolve) => {
          if (!url) {
            resolve();
            return;
          }

          const img = new Image();
          img.decoding = "async";
          img.fetchPriority = "high";
          img.onload = () => resolve();
          img.onerror = () => resolve();
          img.src = url;
        });
      },

      generateCalendarLink() {
        const linkText = "Pernikahan " + this.client.nama_wanita + " dan " + this.client.nama_pria;
        const startDate = moment(this.client.tgl_resepsi).format("YYYYMMDD");
        const startTime = moment(this.client.tgl_resepsi).format("HHmmss");
        const endTime = moment(this.client.tgl_resepsi_selesai).format("HHmmss");
        return `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(linkText)}&details&dates=${startDate}T${startTime}/${startDate}T${endTime}&location`;
      },
      openLightbox(itemOrIndex) {
        const index = typeof itemOrIndex === "number"
          ? itemOrIndex
          : this.gallery.findIndex((galleryItem) => {
              if (!itemOrIndex) return false;
              if (itemOrIndex.id != null && galleryItem.id != null) {
                return galleryItem.id === itemOrIndex.id;
              }
              return galleryItem.file === itemOrIndex.file;
            });

        if (index < 0 || index >= this.gallery.length) return;

        this.currentIndex = index;
        this.lightboxVisible = true;
        if (typeof document !== "undefined" && document.body) {
          document.body.style.overflow = "hidden";
        }
      },
      closeLightbox() {
        this.lightboxVisible = false;
        if (typeof document !== "undefined" && document.body) {
          document.body.style.overflow = "";
        }
      },
      onLightboxKeydown(event) {
        if (!this.lightboxVisible) return;
        if (event.key === "Escape") {
          this.closeLightbox();
        } else if (event.key === "ArrowLeft") {
          this.prevPhoto();
        } else if (event.key === "ArrowRight") {
          this.nextPhoto();
        }
      },
      prevPhoto() {
        if (!this.gallery.length) return;
        this.currentIndex = (this.currentIndex - 1 + this.gallery.length) % this.gallery.length;
      },
      nextPhoto() {
        if (!this.gallery.length) return;
        this.currentIndex = (this.currentIndex + 1) % this.gallery.length;
      },

      prev(event) {
        if (this.$refs.horizontal && typeof this.$refs.horizontal.prev === "function") {
          this.$refs.horizontal.prev(event);
        } else {
          console.error("Horizontal ref or prev method is not defined");
        }
      },
      next(event) {
        if (this.$refs.horizontal && typeof this.$refs.horizontal.next === "function") {
          this.$refs.horizontal.next(event);
        } else {
          console.error("Horizontal ref or next method is not defined");
        }
      },

      onScroll({ hasPrev, hasNext }) {
        this.hasPrev = hasPrev;
        this.hasNext = hasNext;
      },
      checkScroll() {
        const galleryElement = document.querySelector(".show-gallery");
        if (galleryElement) {
          const rect = galleryElement.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
          this.showGallery = isVisible;
          if (isVisible && !this.autoScrollInterval) {
            this.startAutoScroll();
          } else if (!isVisible && this.autoScrollInterval) {
            clearInterval(this.autoScrollInterval);
            this.autoScrollInterval = null;
          }
        }
      },
      startAutoScroll() {
        // Clear existing interval
        if (this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval);
        }
        this.autoScrollInterval = setInterval(() => {
          if (this.hasNext) {
            this.next({ stopPropagation: () => {} });
          } else {
            this.$refs.horizontal.scrollToIndex(0);
          }
        }, 5000);
      },

      startAutoScrollStoryImage() {
        const wrapper = this.$refs.carouselWrapper;
        if (!wrapper) return; // guard: jika ref belum tersedia, batalkan

        let position = 0;
        const speed = 0.5;

        const animate = () => {
          // Cek lagi setiap frame, karena komponen bisa di-unmount kapan saja
          if (!this.$refs.carouselWrapper) {
            cancelAnimationFrame(this._storyScrollRafId);
            return;
          }

          position -= speed;
          wrapper.style.transform = `translate3d(${position}px, 0, 0)`;
          wrapper.style.transitionDuration = "0ms";

          const totalWidth = wrapper.scrollWidth / 2; // karena kita duplikat
          if (Math.abs(position) >= totalWidth) {
            position = 0; // reset saat set pertama selesai
          }

          this._storyScrollRafId = requestAnimationFrame(animate);
        };

        this._storyScrollRafId = requestAnimationFrame(animate);
      },


      handleSubmit(event) {
        if (this.isSubmittingWA) return;
        this.isSubmittingWA = true;

        const form = event.target.closest("form");
        if (!form.checkValidity()) {
          form.reportValidity();
          this.isSubmittingWA = false;
          return;
        }

        let message = `Hai, saya ${this.name} ingin konfirmasi kehadiran undangan pernikahan bahwa ${this.picked}.`;

        // Tambahkan jumlah jika hadir
        if (this.picked === "Iya, Saya akan Hadir" || this.picked === "Yes, I would love to attend") {
          message += ` Jumlah yang hadir adalah ${this.jumlah}.`;
        }

        message += " Terima kasih";

        const url = `https://api.whatsapp.com/send?phone=${this.client.wa_number}&text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");

        setTimeout(() => {
          this.isSubmittingWA = false;
        }, 1500);
      },
      getElapsedTime(created_at) {
            const currentTime = Math.floor(Date.now() / 1000); // Waktu saat ini dalam detik
            const createdAt = Math.floor(new Date(created_at).getTime() / 1000); // Waktu yang diberikan dalam detik

            const timeDifference = currentTime - createdAt;

            if (this.config.language === 1) {
                if (timeDifference < 60) {
                    return 'A few seconds ago'; 
                } else if (timeDifference < 3600) {
                    const minutes = Math.floor(timeDifference / 60);
                    return `${minutes} minutes ago`;
                } else if (timeDifference < 86400) {
                    const hours = Math.floor(timeDifference / 3600);
                    const remainingMinutes = Math.floor((timeDifference % 3600) / 60);
                    return `${hours} hours, ${remainingMinutes} minutes ago`;
                } else {
                    const days = Math.floor(timeDifference / 86400);
                    return `${days} days ago`;
                }
            } else {
                if (timeDifference < 60) {
                    return 'Beberapa detik yang lalu';
                } else if (timeDifference < 3600) {
                    const minutes = Math.floor(timeDifference / 60);
                    return `${minutes} menit yang lalu`;
                } else if (timeDifference < 86400) {
                    const hours = Math.floor(timeDifference / 3600);
                    const remainingMinutes = Math.floor((timeDifference % 3600) / 60);
                    return `${hours} jam, ${remainingMinutes} menit yang lalu`;
                } else {
                    const days = Math.floor(timeDifference / 86400);
                    return `${days} hari yang lalu`;
                }
            }
        },
        handleWishPost(event) {
          // stopImmediatePropagation mencegah jQuery WDP JS intercept submit event
          if (event && event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
          }
          if (this.isSubmittingWish) return;
          this.post();
        },
        post() {
          this.isSubmittingWish = true;
          this.$api.post('comment', this.submit)
          .then(response => {
              this.success = response.data.success
              this.errors = {};
              this.submit.name = '';
              this.submit.comment = '';
              this.submit.confirmation = '';
              this.submit.request_songs = '';
              this.submit.artist = '';
              this.snackbar = true;
              setTimeout(()=>{ this.snackbar=false; }, 3000);
              this.$api.get('comment/' + this.client.id)
                  .then(response => {
                      const raw = response.data.data;
                      this.hopes = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : []);
                  })
                  .finally(() => { this.isSubmittingWish = false; })
          })
          .catch(error => {
              if (error.response && error.response.status === 422) {
                  this.errors = error.response.data.errors;
              } else if (error.response && error.response.status === 401) {
                  this.errors = error.response.data.errors;
              }
          });
        },
        toggleAmplop() {
          this.isAmplopVisible = !this.isAmplopVisible;
        },
    },
    watch: {
      gallery(newVal) {
        this.pages = newVal.length;
      },
      showGallery(newVal) {
        if (newVal && !this.autoScrollInterval) {
          this.startAutoScroll();
        } else if (!newVal && this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval);
          this.autoScrollInterval = null;
        }
      },
    },
  };
</script>

<style scoped>
#snackbar {
  width: 100%;
  white-space: normal;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 14px 24px;
  position: sticky;
  z-index: 999999;
  bottom: 30px;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  word-wrap: break-word;
  box-sizing: border-box;
}

@media only screen and (max-width: 600px) {
  #snackbar {
    font-size: 12px;
    padding: 12px 16px;
  }
}

.wish-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.vue-gallery-section {
  width: 100%;
}

.vue-gallery-masonry {
  column-count: 2;
  column-gap: 4px;
  width: 100%;
}

.vue-gallery-item {
  break-inside: avoid;
  margin-bottom: 4px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border-radius: 2px;
}

.vue-gallery-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.vue-gallery-item:hover .vue-gallery-img {
  transform: scale(1.03);
}

.vue-gallery-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease, opacity 0.3s ease;
  opacity: 0;
}

.vue-gallery-overlay svg {
  width: 24px;
  height: 24px;
  fill: #ffffff;
}

.vue-gallery-item:hover .vue-gallery-overlay {
  background: rgba(0, 0, 0, 0.35);
  opacity: 1;
}

.vue-lightbox-fade-enter-active,
.vue-lightbox-fade-leave-active {
  transition: opacity 0.18s ease;
}

.vue-lightbox-fade-enter,
.vue-lightbox-fade-leave-to {
  opacity: 0;
}

.vue-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.vue-lightbox-img {
  max-width: 92vw;
  max-height: 88vh;
  object-fit: contain;
  border-radius: 2px;
  box-shadow: 0 20px 80px rgba(0, 0, 0, 0.45);
}

.vue-lightbox-close {
  position: absolute;
  top: 16px;
  right: 20px;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 28px;
  cursor: pointer;
  z-index: 1;
}

.vue-lightbox-prev,
.vue-lightbox-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #ffffff;
  font-size: 40px;
  line-height: 1;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 4px;
}

.vue-lightbox-prev:disabled,
.vue-lightbox-next:disabled {
  opacity: 0.45;
  cursor: default;
}

.vue-lightbox-prev { left: 12px; }
.vue-lightbox-next { right: 12px; }

.vue-lightbox-counter {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
}

@media (max-width: 600px) {
  .vue-gallery-masonry {
    column-gap: 3px;
  }

  .vue-gallery-item {
    margin-bottom: 3px;
  }

  .vue-lightbox {
    padding: 16px;
  }

  .vue-lightbox-prev,
  .vue-lightbox-next {
    font-size: 32px;
    padding: 6px 12px;
  }
}

.elementor-element-38111ddf::before {
  background-image: none !important;
}

/* Safari iOS cover image fix - Loading state */
.modalx.cover-loading {
  background-image: none !important;
  background-color: #1b1b1b !important;
}

.modalx.cover-loading .overlayy {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

/* Ensure background image renders properly on Safari */
.modalx {
  background-size: cover !important;
  background-position: center center !important;
  -webkit-background-size: cover !important;
  -webkit-background-position: center center !important;
}

@media (min-width: 768px) {
  .elementor-49887 .elementor-element.elementor-element-77882976 {
    width: 240px !important;
    margin: 0 auto !important;
  }
  .elementor-49887 .elementor-element.elementor-element-5788c62a {
    margin-bottom: 120px !important;
  }
}
</style>


